import { Component, OnInit, DoCheck, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SortPipe } from '../_helpers/sort.pipe';
import { LazyLoadImgDirective } from '../_helpers/lazy-load-img.directive';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { CommonService } from '../_service/common.service';
import { appConfig, intUrl } from '../app.config';
import { interval, Observable, Subject, firstValueFrom } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap, catchError } from 'rxjs/operators';
import { PagerService } from '../_service/pager-service';
import * as XLSX from 'xlsx';
import { ContactsService } from '../_service/contacts.service';
import { SupplierService } from '../_service/supplier.service';
import { SitesService } from '../_service/sites.service';
import { ArcaService } from '../_service/arca.service';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterLink,
        RouterModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatOptionModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatSnackBarModule,
        NgxPaginationModule,
        NgSelectModule,
        NgbModule,
        NgxMatSelectSearchModule,
        SortPipe,
        LazyLoadImgDirective,
        HelpsectionComponent,
        SuppliertabComponent
    ]
})
export class ContactsComponent implements OnInit, DoCheck, OnDestroy {
  private readonly DEBOUNCE_TIME_MS = 400;
  private readonly DEFAULT_MAX_RECORDS_PAGE = 50;
  private readonly ROLE_SEARCH_MAX_RECORDS_PAGE = 20;
  private readonly MIN_IDENTIFIER_LENGTH = 5;
  private readonly MIN_NAME_SEARCH_LENGTH = 2;
  private readonly MIN_IPN_SEARCH_LENGTH = 4;
  private readonly ENTER_KEY_CODE = 13;
  private readonly PAGE_COUNT_THRESHOLD = 10;
  private readonly PAGE_HEIGHT_NAME_ROW_FACTOR = 50;
  private readonly PAGE_HEIGHT_ROLE_ROW_FACTOR = 30;
  private readonly PAGE_HEIGHT_BASE_OFFSET = 300;
  private readonly PAGE_HEIGHT_FALLBACK = 550;
  private readonly IPN_REQUIRED_LENGTH = 7;
  private readonly ESTIMATED_API_CALLS_PER_IPN = 8;
  private readonly PROGRESS_POLL_INTERVAL_MS = 100;
  private readonly IMPORT_BATCH_SIZE = 100;
  private readonly IMPORT_BATCH_DELAY_MS = 1500;
  private readonly IMPORT_COMPLETION_DELAY_MS = 3000;
  private readonly HTTP_NOT_FOUND_CODE = '404';
  private readonly FUNCTION_CODE_LENGTH = 12;
  private readonly COMPANY_CODE_SLICE_PREFIX = 4;
  private readonly COMPANY_CODE_SLICE_SUFFIX = -2;
  private readonly ROLE_TYPE_CODE_SLICE_PREFIX = 6;
  private readonly FUNCTIONAL_ORG_COMPANY_SLICE_SIZE = 8;
  private readonly FUNCTIONAL_ORG_COMPANY_CODE_LENGTH = 6;

  private ngUnsubscribe = new Subject();
  delayIpnInput = new UntypedFormControl();
  Config: any;
  public data: any;
  loading = false;
  loadData = false;
  saveDatas: any = "Save";
  public maxRecorePage = this.DEFAULT_MAX_RECORDS_PAGE;
  public pageinCid: any = [];
  public minlength = this.MIN_IDENTIFIER_LENGTH;
  public PageTotalLength: any = "";
  pager: any = {};
  pageAllinfos: any = [];
  public envHide: any = "";
  public customLoadingTemplate: any;
  public customLoadingTemplate2: any;
  public roleVariableHide = false;
  public prodHide = false;
  public superUserShow: any = false;
  public showBuyerProfile: any = false;
  public showForConsult = false;
  showForSupplier: boolean;
  roleIsManager = false;
  public firstName: any = "";
  public LastName: any = "";
  public CheeckMandatory = false;
  public importIpnInputError = false;
  public importIpnModel: any = '';
  public disableIpnBtn = false;
  public importIpnInvalidError = false;
  public RoleCategoryError = false;
  public personIdData: any = [];
  public emailData: any = [];
  public ipnData: any = [];
  public userRoleData: any = [];
  public userCompanyData: any = [];
  public userGroupData: any = [];
  public userSiteData: any = [];

  companySupplierData: any;
  contactGroupData: any;
  contactSiteData: any;

  identifierTypeModel: any = 'ipn';
  ipnModel: any = '';
  importInvalidText: string;
  roleTypeDesc: any = [];
  PersonRoleSelectOp: any = [];
  contactCompany = '';
  contactFirstName = '';
  contactLastName = '';
  contactRole = '';
  contactIpn = '';
  contactEmail = '';
  contactCellphone = '';
  contactPhone = '';
  CmpConIpnError = false;
  CmpConEmailError = false;
  CmpConCellphoneError = false;
  CmpConCellphoneError2 = false;
  CmpConPhoneError = false;
  CmpConPhoneError2 = false;
  CmpConRoleError = false;
  allAddressDataContact: any = [];
  rowIdsEditObj: any = {};
  contactFirstNameError = false;
  contactLastNameError = false;
  disableContactRoleEdit = false;
  delConRowId = '';
  roleDropdown = false;
  selectedRole: any = '';
  public errorModelOnNgModel =
    {
      'contactIpn': 'CmpConIpnError',
      'contactEmail': 'CmpConEmailError',
      'contactFirstName': 'contactFirstNameError',
      'contactLastName': 'contactLastNameError',
      'contactCellphone': 'CmpConCellphoneError',
      'contactPhone': 'CmpConPhoneError'
    }
  public errorRegExModel =
    {
      'contactCellphone': 'CmpConCellphoneError2',
      'contactPhone': 'CmpConPhoneError2'
    }
  originalContactData: {};
  disableEditContactSaveBtn: boolean;
  counterObj: {};
  contactDetailChanged: boolean;
  allowedRoles = ['adf', 'kam', 'sales contact', 'sales director'];
  ipnModelDropDown = [];
  roleObjDisp = { 'DCC': 'DCC', 'KAM': 'KAM', 'ADF': 'ADF', 'Sales contact': 'Sales contact', 'Sales Director': 'Sales Director' };
  functionalCompanyIds = [];
  pageHeight = 0;
  fileToUpload: File = null;
  arrayOfIpnsToImport: any = [];
  logFileArrayOfIpns: any = [];
  public ipnTextDisplay = 'Loading Please Wait....';
  public showDownloadLog = false;
  public currentIpnImporting: any = '';
  public ipnInError: any;
  public noOfIpnsImported: any = '';
  public totalIpnsToImport: any = '';
  public importIpnByEitherOne = false;
  public loadingNoOfIpnsImported = true;
  fileIsEmpty = false;
  TextForCompleteUpload: any='';
  TextForIpnInError: any='';
  public currentIpnBeingProcessed = '';
  public currentActionCount = 0;
  public activitySpinner = '|';
  private spinnerChars: string[] = ['|', '/', '-', '\\'];
  public currentErrorMessage = '';
  public currentErrorType: 'none' | 'warning' | 'critical' = 'none';
  public hasApiError = false;
  public lastSuccessfulIpn = '';
  public errorDetails = '';
  public totalApiCalls = 0;
  public completedApiCalls = 0;
  public currentIpnApiCalls = 0;
  public estimatedApiCallsPerIpn: number = this.ESTIMATED_API_CALLS_PER_IPN;
  private importIndexInProgress: number | null = null;
  setpage: number;
  personsIds: any = [];
  roleCategory = '';
  roleTypesData = [];
  selectedRoleCategory: any;
  autoload = false;
  enterKey: boolean;
  uploadDocError: boolean;
  public length = 0;
  displayType: string;
  key = 'name';
  reverse = false;
  userData: any;
  addressData: any = null;
  grpData: any;
  personUpdated: boolean;
  personRoles: any = null;
  alladdressesDatas = false;
  supplierRoleloop = false;
  companyRoles: any;
  imported: boolean;
  importCompleted = false;
  importCancelled = false;
  endDateisPresent: boolean;
  ipnnotpresent: boolean;

  constructor(
    private commonService: CommonService,
    private http: HttpClient,
    private router: Router,
    private pagerService: PagerService,
    private contactsservice:ContactsService,
    private Supplierservice:SupplierService,
    private sitesService:SitesService,
    private ArcaService:ArcaService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    this.Config = appConfig;
    this.delayIpnInput.valueChanges.pipe(debounceTime(this.DEBOUNCE_TIME_MS), distinctUntilChanged()).subscribe(value2 => {
      this.ipnModel = value2
      this.autoCmpIpnVals(value2);
    });
  }

  ngOnInit() {
    this.getRoleTypes();
    this.checkLocalStorage();
  }

  geterrorResponse() {
    const data = this.commonService.handleApiError(this.http.get(`${intUrl}/api/oktaIds`) as Observable<any>);
    data.subscribe(_abc => {
    })
  }
  ngDoCheck() {
    this.getRoles();
  }

  getRoles() {
    let RoleByService = this.commonService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  checkAllProfilesAndEnv(RoleByService) {

    const c = RoleByService;
    const roleSource = c['role'];
    const roles = Array.isArray(roleSource)
      ? roleSource.map((role: string) => role.toLowerCase())
      : (typeof roleSource === 'string' && roleSource !== '')
        ? [roleSource.toLowerCase()]
        : [];
    const hasRole = (roleName: string): boolean => roles.includes(roleName);

    if (c['buyer'] == 'yes') {
      this.showBuyerProfile = false;
    } else {
      this.showBuyerProfile = true;
    }
    if (c['env'] == 'qua' || c['env'] == 're7' || c['env'] == 'ope') {
      this.envHide = false;
    } else {
      this.envHide = true;
    }
    if (hasRole('admin')) {
      this.roleVariableHide = true;
    } else {
      this.roleVariableHide = false;
    }
    if (hasRole('manager')) {
      this.roleIsManager = true;
    } else {
      this.roleIsManager = false;
    }
    if (c['superAdmin'] == 'yes') {
      this.superUserShow = true;
    } else {
      this.superUserShow = false;
      if (this.showBuyerProfile && (!this.roleVariableHide) && (!this.roleIsManager) && (this.showForConsult)) {
        this.router.navigateByUrl('/company');
      }
    }
    if (c['env'] == 'ope') {
      this.prodHide = true;
    } else {
      this.prodHide = false;
    }


    if (hasRole('consult')) {
      this.showForConsult = false;
    } else {
      this.showForConsult = true;
    }
    if (hasRole('supplier')) {
      this.showForSupplier = false;
    } else {
      this.showForSupplier = true;
    }
  }

  getSearch(page = 1) {
    this.setpage = page;
    this.CheeckMandatory = false;
    this.data = "";
    this.data = [];
    this.userRoleData = [];
    this.userCompanyData = [];
    this.userGroupData = [];
    this.userSiteData = [];
    this.companySupplierData = [];
    this.contactGroupData = [];
    this.contactSiteData = [];

    this.loadData = false;
    const personsIds = [];
    const firstname = this.firstName.trim();
    const lastname = this.LastName.trim();
    this.maxRecorePage = this.DEFAULT_MAX_RECORDS_PAGE;
    if ((firstname != '' || lastname != '') && (firstname.length > this.MIN_NAME_SEARCH_LENGTH || lastname.length > this.MIN_NAME_SEARCH_LENGTH)) {
      this.displayType = ' Contacts'
      let srchParam = ''
      if (firstname.length > this.MIN_NAME_SEARCH_LENGTH && lastname.length > this.MIN_NAME_SEARCH_LENGTH) {
        srchParam = `persons?personFirstName=*${this.firstName}*&personLastName=*${this.LastName}*`;
      } else {
        if (firstname != '' && firstname.length > this.MIN_NAME_SEARCH_LENGTH && lastname.length <= this.MIN_NAME_SEARCH_LENGTH) {
          this.LastName = '';
          srchParam = `persons?personFirstName=*${this.firstName}*`;
        }
        if (lastname != '' && lastname.length > this.MIN_NAME_SEARCH_LENGTH && firstname.length <= this.MIN_NAME_SEARCH_LENGTH) {
          this.firstName = '';
          srchParam = `persons?personLastName=*${this.LastName}*`;
        }
      }
      this.loading = true;
      this.contactsservice.getPersons(`${this.Config.ApinewContactsUrl}${srchParam}&_page=${this.setpage}&_pagesize=${this.maxRecorePage}`).subscribe(getContacts => {
        if (getContacts['persons'].length > 0) {
          this.pager = this.pagerService.getPager(getContacts['count'], getContacts['page'], this.maxRecorePage);
          this.PageTotalLength = getContacts['count'];
          if (getContacts['pageCount'] <= this.PAGE_COUNT_THRESHOLD) {
            this.pageHeight = getContacts['pageCount'] * this.PAGE_HEIGHT_NAME_ROW_FACTOR + this.PAGE_HEIGHT_BASE_OFFSET;
          } else {
            this.pageHeight = this.PAGE_HEIGHT_FALLBACK;
          }
          getContacts['persons'].forEach(ele => {
            this.data[ele.rowId] = ele;
            this.personIdData[ele.rowId] = ele;
            if (personsIds.indexOf(ele.rowId) == -1 && (ele.rowId) != '') {
              personsIds.push(ele.rowId);
            }
          });
          this.sortGetData(page, personsIds, 'names');
        } else {
          this.loading = false;
          this.loadData = false;
        }
      });
    } else if (this.ipnModel.trim().length > this.MIN_IPN_SEARCH_LENGTH) {
      if (this.identifierTypeModel == 'ipn') {
        this.displayType = ' Roles'
        this.getIpnSearch(page);
      } else {
        this.displayType = ' Contact'
        this.getEmailsSearch(page);
      }
    } else if (this.selectedRole != '' || (this.roleCategory != '' && this.roleCategory != undefined && this.roleCategory != null)) {
      this.displayType = ' Roles'
      this.getRoleSearch(page);
    } else if (firstname == '' && lastname == '' && this.ipnModel.trim() == '' && this.selectedRole == '') {
      this.displayType = ' Contacts'
      this.getpersonIdies(page);
    } else {
    }
  }
  getpersonIdies(page, subscribeData = []) {
    this.loading = true;
    this.contactsservice.getPersons(`${this.Config.ApinewContactsUrl}persons?_page=${page}&_pagesize=${this.maxRecorePage}`).subscribe(getContacts => {
      if (getContacts['persons'].length > 0) {
        this.maxRecorePage = this.DEFAULT_MAX_RECORDS_PAGE
        this.pager = this.pagerService.getPager(getContacts['count'], getContacts['page'], this.maxRecorePage);
        this.PageTotalLength = getContacts['count'];
        if (getContacts['pageCount'] <= this.PAGE_COUNT_THRESHOLD) {
          this.pageHeight = getContacts['pageCount'] * this.PAGE_HEIGHT_ROLE_ROW_FACTOR + this.PAGE_HEIGHT_BASE_OFFSET;
        } else {
          this.pageHeight = this.PAGE_HEIGHT_FALLBACK;
        }
        getContacts['persons'].forEach(ele => {
          this.data[ele.rowId] = ele;
          this.personIdData[ele.rowId] = ele;
          if (subscribeData.indexOf(ele.rowId) == -1) {
            subscribeData.push(ele.rowId);
          }
        });
        this.personsIds = subscribeData;

        this.sortGetData(getContacts['page'], this.personsIds, 'names');
      } else {
        this.loading = false;
        this.loadData = false;
      }
    });
  }

  sortGetData(_page, personsIds, from = '') {
    if (personsIds.length > 0) {
      if (from == 'ipn') {
        this.getEmailSearch(personsIds);
        this.getPersonsIds(personsIds, 'forIpn');
      } else if (from == 'names') {
        this.getEmailSearch(personsIds);
        this.getUserIpns(personsIds);
        this.getUserRoles(personsIds, from);
      } else if (from == 'role') {
        this.getEmailSearch(personsIds);
        this.getPersonsIds(personsIds, 'role');
        this.getUserIpns(personsIds);
      } else if (from == 'email') {
        this.getEmailSearch(personsIds);
        this.getPersonsIds(personsIds, 'forIpn');
        this.getUserIpns(personsIds);
      } else {
      }
    } else {
      this.loading = false;
      this.loadData = false;
    }

  }

  getIpnSearch(page) {
    const ipn = this.ipnModel.trim();
    if (ipn != '' && ipn.length > this.MIN_IPN_SEARCH_LENGTH) {
      this.ipnModelDropDown = [];
      this.loading = true;
      const personsIds = [];
      this.contactsservice.getUsers(`${this.Config.ApinewContactsUrl}users?loginId=*${ipn}*&loginType=RENAULT_IPN&_page=${page}&_pagesize=${this.maxRecorePage}`).subscribe(data => {
        if (data['users'].length > 0) {
          if (data['pageCount'] <= this.PAGE_COUNT_THRESHOLD) {
            this.pageHeight = data['pageCount'] * this.PAGE_HEIGHT_ROLE_ROW_FACTOR + this.PAGE_HEIGHT_BASE_OFFSET;
          } else {
            this.pageHeight = this.PAGE_HEIGHT_FALLBACK;
          }
          data['users'].forEach(element => {
            if (element.endDate) {
              element['ipnnotpresent'] = true;
            } else {
              element['ipnnotpresent'] = false;
            }
            this.ipnData[element.personRowId] = element;
            if (personsIds.indexOf(element.personRowId) == -1) {
              personsIds.push(element.personRowId);
            }
          });
          this.sortGetData(page, personsIds, 'ipn');
        } else {
          this.loadData = false;
          this.loading = false;
        }
      });
    }
  }

  getEmailsSearch(page) {
    const ipn = this.ipnModel.trim();
    if (ipn != '' && ipn.length > this.MIN_IPN_SEARCH_LENGTH) {
      this.ipnModelDropDown = [];
      this.loading = true;
      const personsIds = [];
      this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=${ipn.replaceAll('*', '%2A').replaceAll('@', '%40').replaceAll('.', '%2E')}&_page=${page}`).subscribe(data => {
        if (data['personAddresses'].length > 0) {
          this.pager = this.pagerService.getPager(data['count'], data['page'], this.maxRecorePage);
          if (data['pageCount'] <= this.PAGE_COUNT_THRESHOLD) {
            this.pageHeight = data['pageCount'] * this.PAGE_HEIGHT_ROLE_ROW_FACTOR + this.PAGE_HEIGHT_BASE_OFFSET;
          } else {
            this.pageHeight = this.PAGE_HEIGHT_FALLBACK;
          }
          data['personAddresses'].forEach(element => {
            this.ipnData[element.personRowId] = element;
            if (personsIds.indexOf(element.personRowId) == -1) {
              personsIds.push(element.personRowId);
            }
          });
          this.sortGetData(page, personsIds, 'email');
        } else {
          this.loadData = false;
          this.loading = false;
        }
      });
    }
  }

  getPersonsIds(personsIds, from = '', page = 1) {
    this.contactsservice.getPersons(`${this.Config.ApinewContactsUrl}persons?rowId=in(${personsIds})&_page=${page}`).subscribe(getContacts => {
      this.data = [];
      if (getContacts['persons'].length > 0) {
        this.data = getContacts['persons'];
        getContacts['persons'].forEach(ele => {
          this.data[ele.rowId] = ele;
          this.personIdData[ele.rowId] = ele;
          if (personsIds.indexOf(ele.rowId) == -1) {
            personsIds.push(ele.rowId);
          }
        });
      } else {
        this.loading = false;
        this.loadData = false;
      }
      if (from == 'forIpn') {
        this.getUserRoles(personsIds, 'from');
      }
      if (from == 'role') {
      }
    });
  }

  getEmailSearch(personsIds, page = 1) {
    this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=in(${personsIds})&_page=${page}`).subscribe(data => {
      if (data['personAddresses'].length > 0) {
        data['personAddresses'].forEach(element => {
          if (element.addressType.toLowerCase() == 'email') {
            this.emailData[element.personRowId] = element;
          }
          if (this.allAddressDataContact[element.personRowId] == undefined) {
            this.allAddressDataContact[element.personRowId] = [];
          }
          this.allAddressDataContact[element.personRowId].push(element);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getEmailSearch(personsIds, page + 1);
        }
      }
    });
  }

  getUserIpns(personsIds, page = 1) {
    this.contactsservice.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=in(${personsIds})&_page=${page}`).subscribe(data => {
      if (data['users'].length > 0) {
        data['users'].forEach(element => {
          if (element.endDate) {
            element['ipnnotpresent'] = true;
          } else {
            element['ipnnotpresent'] = false;
          }
          this.ipnData[element.personRowId] = element;
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getUserIpns(personsIds, page + 1);
        }
      }
    });
  }

  getUserRoles(personsIds, from, page = 1, subscribeData = []) {
    const pages = page
    this.contactsservice.getPersonRoles(`${this.Config.ApinewContactsUrl}personRoles?personRowId=in(${personsIds})&_page=${page}`).subscribe(data => {
      if (data['personRoles'].length > 0) {
        if (from == 'from' && this.identifierTypeModel == 'ipn') {
          this.pager = this.pagerService.getPager(data['count'], data['page'], this.maxRecorePage);
          this.PageTotalLength = data['count'];
          if (data['pageCount'] <= this.PAGE_COUNT_THRESHOLD) {
            this.pageHeight = data['pageCount'] * this.PAGE_HEIGHT_ROLE_ROW_FACTOR + this.PAGE_HEIGHT_BASE_OFFSET;
          } else {
            this.pageHeight = this.PAGE_HEIGHT_FALLBACK;
          }
        }
        if (from == 'role' && this.selectedRole == '') {
          let type = "";
          if (this.roleCategory.toLowerCase() == "company contact") {
            type = 'company'

          } else if (this.roleCategory.toLowerCase() == "group contact") {
            type = 'group'
          }
          else if (this.roleCategory.toLowerCase() == "site contact") {
            type = 'site'
          } else {
          }

          data['personRoles'].forEach(element => {
            if (element.type == type.toUpperCase()) {
              subscribeData.push(element);
            }
          });
        } else {
          data['personRoles'].forEach(element => {
            subscribeData.push(element);
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getUserRoles(personsIds, from, page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          this.userRoleData = [];
          const tempData = [];
          subscribeData.forEach(element => {
            if (this.selectedRole != '') {
              if (element.roleTypeCode == this.selectedRole) {
                this.userRoleData.push(element);
              }
            } else {
              this.userRoleData.push(element);
            }
          });
          const tempPersonId = [];
          this.userRoleData.forEach(e => {
            if (this.data[e.personRowId]) {
              tempPersonId.push(e.personRowId);
              e['personIdentifier'] = this.data[e.personRowId]['personIdentifier'];
              e['personFirstName'] = this.data[e.personRowId]['personFirstName'];
              e['personLastName'] = this.data[e.personRowId]['personLastName'];
              e['personRowId'] = this.data[e.personRowId]['rowId'];
            }
          });
          personsIds.forEach(e => {
            if (tempPersonId.indexOf(e) == -1) {
              if (this.data[e]) {
                const con = {};
                con['personIdentifier'] = this.data[e]['personIdentifier'];
                con['personFirstName'] = this.data[e]['personFirstName'];
                con['personLastName'] = this.data[e]['personLastName'];
                con['personRowId'] = this.data[e]['rowId'];
                this.userRoleData.push(con);
              }
            }
          })
          this.data = "";
          this.data = [];
        } else {
        }
      } else {
        this.data.forEach(e => {
          const con = {}
          con['personIdentifier'] = e['personIdentifier'];
          con['personFirstName'] = e['personFirstName'];
          con['personLastName'] = e['personLastName'];
          con['personRowId'] = e['rowId'];
          this.userRoleData.push(con);
        });
      }
      if (data['maxPage'] == page) {
        this.loadData = true;
        this.loading = false;
        this.getUserCompany(personsIds);
        this.getUserGroup(personsIds);
        this.getUserSite(personsIds);
      }
    });
  }

  restAlldatas(_ss) {
    this.selectedRole = '';
    this.ipnModel = '';
    this.roleCategory = '';
    this.userRoleData = []
    this.pager = this.pagerService.getPager(0, 1, 1)
    this.loadData = false
  }
  getUserGroup(personsIds, groupIds = [], page = 1) {
    if (personsIds.length > 0) {
      this.contactsservice.getSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles?personRowId=in(${personsIds})&_page=${page}`).subscribe(data => {
        if (data['supplierGroupRoles'].length > 0) {
          data['supplierGroupRoles'].forEach(e => {
            let grpId: any;
            if (e.supplierGroup) {
              if (typeof e.supplierGroup === 'string') {
                grpId = e.supplierGroup.split(':');
                groupIds.push(grpId[1]);
              } else {
                grpId = e.supplierGroup.href.split('/');
                groupIds.push(grpId[1]);
              }
            }
            if (this.userGroupData[e.personRowId] == undefined) {
              this.userGroupData[e.personRowId] = [];
            }
            if (this.userGroupData[e.personRowId][e.rowId] == undefined) {
              this.userGroupData[e.personRowId][e.rowId] = [];
            }
            let id = ''
            if (typeof e.supplierGroup === 'string') {
              id = e.supplierGroup.split(':')[1]
            } else {
              id = e.supplierGroup.href.split('/')[1]
            }
            this.userGroupData[e.personRowId][e.rowId] = e;
            this.userGroupData[e.personRowId][e.rowId].groupId = id;
          })
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getUserGroup(personsIds, groupIds, page + 1);
          } else if (data['maxPage'] == page) {
            this.getGroupsList(groupIds);
          } else {
          }
        } else {
          this.loadData = true;
          this.loading = false;
        }
      })
    } else {
      this.loading = false;
      this.loadData = true;
    }
  }
  getGroupsList(groupIds, page = 1) {
    if (groupIds.length > 0) {
      this.Supplierservice.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?groupId=in(${groupIds})&_page=${page}`).subscribe(data => {
        if (data['group-assignments'].length > 0) {
          data['group-assignments'].forEach(e => {
            this.contactGroupData[e.groupId] = e
          })
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getGroupsList(groupIds, page + 1);
          } else if (data['maxPage'] == page) {
            this.loadData = true;
            this.loading = false;
          } else {
          }
        } else {
          this.loading = false;
          this.loadData = true;
        }
      })
    } else {
      this.loadData = true;
      this.loading = false;
    }
  }

  getUserCompany(personsIds, companyIds = [], page = 1) {
    if (personsIds.length > 0) {
      this.contactsservice.getSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles?personRowId=in(${personsIds})&_page=${page}`).subscribe(data => {
        if (data['supplierCompanyRoles'].length > 0) {
          data['supplierCompanyRoles'].forEach(e => {
            if (e.personRoleStatus.toLowerCase() != 'archived') {
              let cpyId: any;
              if (e.personSupplierCompany) {
                if (typeof e.personSupplierCompany === 'string') {
                  cpyId = e.personSupplierCompany.split(":");
                } else {
                  cpyId = e.personSupplierCompany.href.split("/");
                }
                if (companyIds.indexOf(cpyId[1]) == -1) {
                  companyIds.push(cpyId[1]);
                }
                e['companyId'] = cpyId[1];
              }
              if (this.userCompanyData[e.personRowId] == undefined) {
                this.userCompanyData[e.personRowId] = [];
              }
              if (this.userCompanyData[e.personRowId][e.rowId] == undefined) {
                this.userCompanyData[e.personRowId][e.rowId] = [];
              }
              this.userCompanyData[e.personRowId][e.rowId] = e;
            }
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getUserCompany(personsIds, companyIds, page + 1);
          } else if (data['maxPage'] == page) {
            this.getCompaniesList(companyIds);
          } else {
          }
        } else {
          this.loadData = true;
          this.loading = false;
        }
      });
    } else {
      this.loading = false;
      this.loadData = true;
    }
  }

  getCompaniesList(companyIds, page = 1) {
    if (companyIds.length > 0) {
      this.Supplierservice.getCompanies(`${this.Config.ApiSupplierUrl}companies?rowId=in(${companyIds})&_page=${page}`).subscribe(data => {
        if (data['companies'].length > 0) {
          data['companies'].forEach(e => {
            this.companySupplierData[e.rowId] = e;
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getCompaniesList(companyIds, page + 1);
          } else if (data['maxPage'] == page) {
            this.loadData = true;
            this.loading = false;
          } else {
          }
        } else {
          this.loading = false;
          this.loadData = true;
        }
      });
    } else {
      this.loadData = true;
      this.loading = false;
    }
  }

  getUserSite(personsIds, siteIds = [], page = 1) {
    if (personsIds.length > 0) {
      this.contactsservice.getSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles?personRowId=in(${personsIds})&_page=${page}`).subscribe(data => {
        if (data['supplierSiteRoles'].length > 0) {
          data['supplierSiteRoles'].forEach(e => {
            let siteId: any;
            let companyId: any;
            if (e.site) {
              if (typeof e.site === 'string') {
                siteId = e.site.split(':');
              } else {
                siteId = e.site.href.split('/');
              }
              siteIds.push(siteId[1]);
              e['siteId'] = siteId[1];
            }
            if (e.personSupplierCompany) {
              if (typeof e.personSupplierCompany === 'string') {
                companyId = e.personSupplierCompany.split(":");
              } else {
                companyId = e.personSupplierCompany.href.split("/");
              }
              companyId.push(companyId[1]);
              e['companyId'] = companyId[1];
            }
            if (this.userSiteData[e.personRowId] == undefined) {
              this.userSiteData[e.personRowId] = [];
            }
            if (this.userSiteData[e.personRowId][e.rowId] == undefined) {
              this.userSiteData[e.personRowId][e.rowId] = [];
            }
            this.userSiteData[e.personRowId][e.rowId] = e;
          })
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getUserSite(personsIds, siteIds, page + 1);
          } else if (data['maxPage'] == page) {
            this.getSitesList(siteIds);
          } else {
          }
        } else {
          this.loadData = true;
          this.loading = false;
        }
      })
    } else {
      this.loading = false;
      this.loadData = true;
    }
  }
  getSitesList(siteIds, page = 1) {
    if (siteIds.length > 0) {
      this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${siteIds})&_page=${page}`).subscribe(data => {
        if (data['access-points'].length > 0) {
          data['access-points'].forEach(e => {
            this.contactSiteData[e.realEstateAssetId] = e
          })
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getSitesList(siteIds, page + 1);
          } else if (data['maxPage'] == page) {
            this.loadData = true;
            this.loading = false;
          } else {
          }
        } else {
          this.loading = false;
          this.loadData = true;
        }
      })
    } else {
      this.loadData = true;
      this.loading = false;
    }
  }

  selectedCIddentifier2(_event: any, _from = "", _valueFromusr: any, page = 1, byClick = "No") {
    if (byClick == "cked") {
      this.loading = true;
      this.data = "";
      this.data = [];
    }
    this.getSearch(page);
  }

  clearFields(resetparam: any) {
    if (resetparam == "All") {
      this.firstName = "";
      this.LastName = "";
      this.data = "";
      this.loadData = false;
      this.loading = false;
      this.ipnModel = '';
      this.delayIpnInput.setValue('')
      this.selectedRole = '';
      this.roleCategory = '';
      this.CheeckMandatory = false;
      this.RoleCategoryError = false;
    } else if (resetparam == 'firstName') {
      this.firstName = "";
    } else if (resetparam == 'LastName') {
      this.LastName = "";
    } else if (resetparam == 'ipn') {
      this.ipnModel = "";
      this.delayIpnInput.setValue('')
    } else {
    }
  }

  resetOtherFields(val, _event) {
    if (val == 'ipn') {
      this.firstName = '';
      this.LastName = '';
      this.selectedRole = ''
    } else if (val == 'firstName' || val == 'lastName') {
      this.ipnModel = '';
      this.selectedRole = '';
    } else if (val == 'role') {
      this.firstName = '';
      this.LastName = '';
      this.ipnModel = '';
    } else {
    }
  }

  onItemKey(event) {
    if (event["keyCode"] == this.ENTER_KEY_CODE) {
      this.enterKey = false;
      this.getSearch();
    } else {
      this.enterKey = true;
    }
  }


  hideEnv() {
    const c = this.commonService.getEnvSpecific();
    if (c == 'ope') {
      this.prodHide = true;
    } else { this.prodHide = false };
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  updateActivityIndicator() {
    this.currentActionCount++;
    const spinnerIndex = this.currentActionCount % this.spinnerChars.length;
    this.activitySpinner = this.spinnerChars[spinnerIndex];
  }

  resetActivityForNewIpn(ipn: string) {
    this.currentIpnBeingProcessed = ipn;
    this.currentActionCount = 0;
    this.activitySpinner = this.spinnerChars[0];
    this.currentErrorMessage = '';
    this.currentErrorType = 'none';
    this.errorDetails = '';
    this.currentIpnApiCalls = 0;
  }

  setErrorStatus(message: string, type: 'warning' | 'critical', details = '') {
    this.currentErrorMessage = message;
    this.currentErrorType = type;
    this.errorDetails = details;
    this.hasApiError = type === 'critical';
  }

  clearErrorStatus() {
    this.currentErrorMessage = '';
    this.currentErrorType = 'none';
    this.errorDetails = '';
    this.hasApiError = false;
  }

  private addImportError(ipn: string, error: string): void {
    if (!this.logFileArrayOfIpns.some(item => item.ipn === ipn)) {
      this.logFileArrayOfIpns.push({ ipn, error });
      localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
    }
  }

  retryImport() {
    this.clearErrorStatus();
    this.importIndexInProgress = null;
    const currentIpnIndex = parseInt(localStorage.getItem("currentIpnImporting") || "0");
    const noOfIpnsImported = parseInt(localStorage.getItem("noOfIpnsImported") || "0");
    const ipnInError = parseInt(localStorage.getItem("ipnInError") || "0");
    const arrayOfIpns = JSON.parse(localStorage.getItem("tempIpnsInFileForLocal") || "[]");

    if (arrayOfIpns.length > 0)
       {
      this.importIpnByFileFunction(arrayOfIpns, currentIpnIndex, noOfIpnsImported, ipnInError);
    }
  }

  skipAndContinue() {
    this.clearErrorStatus();
    const currentIpnIndex = parseInt(localStorage.getItem("currentIpnImporting") || "0");
    const noOfIpnsImported = parseInt(localStorage.getItem("noOfIpnsImported") || "0");
    let ipnInError = parseInt(localStorage.getItem("ipnInError") || "0");
    const arrayOfIpns = JSON.parse(localStorage.getItem("tempIpnsInFileForLocal") || "[]");
    this.logFileArrayOfIpns.push({
      "ipn": this.currentIpnBeingProcessed,
      "error": `Skipped due to critical error: ${this.currentErrorMessage}`
    });
    localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
    ipnInError++;
    this.ipnInError = ipnInError;
    this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
    localStorage.setItem("ipnInError", ipnInError.toString());

    if (currentIpnIndex < arrayOfIpns.length - 1) {
      this.importIpnByFileFunction(arrayOfIpns, currentIpnIndex + 1, noOfIpnsImported, ipnInError);
    } else {
      this.importCompleted = true;
    }
  }

  setImportInput() {
    this.importIpnModel = '';
    this.importIpnInputError = false;
    this.disableIpnBtn = false;
    this.importIpnInvalidError = false;
    this.fileToUpload = null;
    this.arrayOfIpnsToImport = [];
    this.fileIsEmpty = false;
    this.uploadDocError = false;
    this.importIpnByEitherOne = false;
    const inputFile = document.getElementById("file") as HTMLInputElement;
    if (inputFile) {
      inputFile.value = "";
    }
  }

  clearImportLocalStorage() {
    this.importCancelled = true;
    this.importIndexInProgress = null;
    
    localStorage.removeItem("currentIpnImporting");
    localStorage.removeItem("tempIpnsInFileForLocal");
    localStorage.removeItem("noOfIpnsImported");
    localStorage.removeItem("ipnInError");
    localStorage.removeItem("totalIpnsToImport");
    localStorage.removeItem("logFileArrayOfIpns");
    
    this.currentIpnBeingProcessed = '';
    this.currentIpnImporting = null;
    this.noOfIpnsImported = '';
    this.totalIpnsToImport = '';
    this.ipnInError = null;
    this.logFileArrayOfIpns = [];
    this.showDownloadLog = false;
    this.loadingNoOfIpnsImported = true;
    this.TextForCompleteUpload = '';
    this.TextForIpnInError = '';
    this.currentErrorType = 'none';
    this.currentErrorMessage = '';
    this.errorDetails = '';
    this.currentActionCount = 0;
    this.activitySpinner = this.spinnerChars[0];
    this.importCompleted = false;
    this.ipnTextDisplay = 'Loading Please Wait....';
    
  }

  async ImportIPN() {
    if (this.importIpnModel != '' && this.importIpnModel != undefined && this.arrayOfIpnsToImport.length === 0 && this.uploadDocError == false) {
      this.importIpnInputError = false;
      this.functionalCompanyIds = [];
      this.disableIpnBtn = true;
      this.importIpnInvalidError = false;
      this.importInvalidText = '';
      let ipnData: any;
      let companyData: any;
      const allRoles = [];
      const inputFile = document.getElementById("file") as HTMLInputElement;
      if (inputFile) {
        inputFile.value = "";
      }
      this.fileIsEmpty = false;
      this.uploadDocError = false;
      this.addressData = null;
      this.userData = null;
      this.alladdressesDatas = false;
      this.supplierRoleloop = false;
      this.personUpdated = false;
      this.ArcaService.getPerson(`${this.Config.ApiArcaURL}Person('${this.importIpnModel}')`).subscribe((data: any) => {
        if (data != null) {
          ipnData = data;
          
          if (!data['Mail'] || data['Mail'] === '' || data['Mail'] === undefined || data['Mail'] === null) {
            const errorMsg = `The IPN ${this.importIpnModel} has no email address in ARCA`;
            this.importInvalidText = errorMsg;
            this.importIpnInvalidError = true;
            this.disableIpnBtn = false;
            return;
          }
          
          if (data['Phone']) {
            data['Phone'][0] = data['Phone'][0].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim();
          }
          if (data['MobilePhoneNumber']) {
            data['MobilePhoneNumber'][0] = data['MobilePhoneNumber'][0].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim();
          }
          if (data['PersonTypeDescription'] && data['PersonTypeDescription'].toLowerCase() == 'b2b renault supplier') {
            this.ArcaService.getPerson(`${this.Config.ApiArcaURL}Person('${this.importIpnModel}')/AdministrativeOrganizations`).subscribe(async (data1: any) => {
              if (data1 != null) {
                let alcor: string;
                let alcorTemp: string;
                data1.forEach(e => {
                  if (e.Type == 'ENTT') {
                    alcorTemp = e.Code;
                    alcor = alcorTemp.slice(-this.ROLE_TYPE_CODE_SLICE_PREFIX);
                  }
                });
                if (alcor != '') {
                  this.Supplierservice.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&value=${alcor}`).subscribe(data2 => {
                    if (Array.isArray(data2?.['company-identifiers']) && data2['company-identifiers'].length > 0) {
                      const companyId = data2['company-identifiers'][0]['linkedCompanyId'];
                      this.Supplierservice.getCompanies(`${this.Config.ApiSupplierUrl}companies/${companyId}`).subscribe(data3 => {
                        if (data3 != null) {
                          companyData = data3;
                          this.ArcaService.getgroup(`${this.Config.ApiArcaURL}Group?$filter=(GroupsSetDomain eq 'GCF' or GroupsSetDomain eq 'FRA') and (GroupsSetId eq 'Purchasing Supplier Contacts' or GroupsSetId eq 'GROUPES ADF' or GroupsSetId eq 'GROUPES ADF - V2') and Uid eq '${this.importIpnModel}'`).subscribe(async (data4: any) => {
                            this.grpData = data4;
                            if (data4 != null) {
                              try {
                                if (data4['value']) {
                                  data4['value'].forEach(e => {
                                    if (e.Description.toLowerCase().includes('adf')) {
                                      allRoles.push('ADF');
                                    } else if (e.Description.toLowerCase().includes('kam')) {
                                      allRoles.push('KAM');
                                    } else if (e.Description.toLowerCase().includes('sales contact')) {
                                      allRoles.push('SAL');
                                    } else if (e.Description.toLowerCase().includes('sales director')) {
                                      allRoles.push('SAD');
                                    } else {
                                    }
                                  });
                                }
                              } catch (error) {
                              }
                            }
                            await this.checkForIpnInRfcSync(ipnData, companyData, ipnData['Uid'], allRoles, this.importIpnModel);
                            await this.ImportfuncRoles(ipnData)

                          }, async _error => {
                            await this.checkForIpnInRfcSync(ipnData, companyData, ipnData['Uid'], allRoles, this.importIpnModel);
                            await this.ImportfuncRoles(ipnData)
                          });
                        } else {
                          this.importInvalidText = `Company${alcor}not found in ISA`;
                          this.importIpnInvalidError = true;
                          this.disableIpnBtn = false;
                        }
                      });
                    } else {
                      this.importInvalidText = `Company${alcor}not found in ISA`;
                      this.importIpnInvalidError = true;
                      this.disableIpnBtn = false;
                    }
                  });
                }
              } else {
                this.importInvalidText = 'ALCOR code is empty in ARCA';
                this.importIpnInvalidError = true;
                this.disableIpnBtn = false;
              }
            }, _error => {
              this.importInvalidText = 'ALCOR code is empty in ARCA';
              this.importIpnInvalidError = true;
              this.disableIpnBtn = false;
            });

          } else {
            this.importInvalidText = 'Only Supplier IPN may be imported';
            this.importIpnInvalidError = true;
            this.disableIpnBtn = false;
          }
        } else {
          this.importInvalidText = 'Invalid IPN';
          this.importIpnInvalidError = true;
          this.disableIpnBtn = false;
        }
      }, _error => {
        this.importInvalidText = 'Invalid IPN';
        this.importIpnInvalidError = true;
        this.disableIpnBtn = false;
      });

    } else if ((this.importIpnModel == '' || this.importIpnModel == undefined) && this.arrayOfIpnsToImport.length > 0) {
      this.importIpnInputError = false;
      this.importIndexInProgress = null;
      this.disableIpnBtn = true;
      this.importIpnInvalidError = false;
      this.importInvalidText = '';
      this.ipnInError = 0;
      this.noOfIpnsImported = 0;
      this.currentIpnImporting = 0;
      this.loadingNoOfIpnsImported = true;
      this.currentIpnBeingProcessed = '';
      this.currentActionCount = 0;
      this.activitySpinner = this.spinnerChars[0];
      this.addressData = null;
      this.userData = null;
      this.alladdressesDatas = false;
      this.supplierRoleloop = false;
      this.personUpdated = false;
      document.getElementById('closeImportIpn').click();
      document.getElementById('btnForImportIpnByFile').click();
      localStorage.setItem("tempIpnsInFileForLocal", JSON.stringify(this.arrayOfIpnsToImport));
      this.totalIpnsToImport = this.arrayOfIpnsToImport.length;
      localStorage.setItem("totalIpnsToImport", this.arrayOfIpnsToImport.length);
      this.importArrayOfIpnsStartFn(this.arrayOfIpnsToImport);
      this.functionalCompanyIds = [];
      this.logFileArrayOfIpns = [];
    } else if (this.importIpnModel != '' && this.importIpnModel != undefined && this.arrayOfIpnsToImport.length > 0) {
      this.importIpnByEitherOne = true;
    } else if ((this.importIpnModel == '' || this.importIpnModel == undefined) && this.arrayOfIpnsToImport.length === 0) {
      this.fileIsEmpty = true;
    } else {
      this.importIpnInvalidError = false;
      this.disableIpnBtn = false;
      this.importIpnInputError = true;
      this.fileIsEmpty = false;
    }
  }

  resetIpnInput() {
    this.importIpnModel = '';
    this.importInvalidText = '';
    this.importIpnInputError = false;
  }

  private updateApiProgress() {
    this.completedApiCalls++;
    this.currentIpnApiCalls++;
    this.ngZone.run(() => {
      this.cdr.detectChanges();
    });
  }
  private trackApi<T>(observable: Observable<T>, _apiName = 'API'): Observable<T> {
    const startTime = Date.now();
    
    return observable.pipe(
      tap((_response) => {
        const duration = Date.now() - startTime;
        this.updateApiProgress();
      }),
      catchError((error) => {
        const duration = Date.now() - startTime;
        throw error; 
      })
    );
  }

  async importArrayOfIpnsStartFn(array, currentIpnImporting = 0, noOfIpnsImported = 0, ipnInError = 0) {
    this.importCancelled = false;
    
    this.showDownloadLog = false;
    this.ipnTextDisplay = '';
    this.totalApiCalls = array.length * this.estimatedApiCallsPerIpn;
    this.completedApiCalls = 0;
    this.TextForCompleteUpload = `Importing ${noOfIpnsImported} of ${(array.length)} `;
    if (ipnInError < 1) {
      this.TextForIpnInError = '';
    } else {
      this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
    }
    await this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
  }

  async importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError) {
    if (this.importCancelled) {
      return;
    }

    if (this.importIndexInProgress === currentIpnImporting ||
        (typeof this.currentIpnImporting === 'number' && currentIpnImporting < this.currentIpnImporting)) {
      return;
    }

    this.importIndexInProgress = currentIpnImporting;
    
    let companyData: any;
    this.addressData = null;
    this.userData = null;
    this.alladdressesDatas = false;
    this.supplierRoleloop = false;
    this.personUpdated = false;
    this.imported = false
    this.importCompleted = false;
    this.currentIpnImporting = currentIpnImporting;
    localStorage.setItem("currentIpnImporting", this.currentIpnImporting);
console.log('Importing IPN:', array[currentIpnImporting], 'Index:', currentIpnImporting, 'Total:', array.length);
    this.ngZone.run(() => {
      this.noOfIpnsImported = noOfIpnsImported;
      this.totalIpnsToImport = array.length;
      this.totalApiCalls = array.length * this.estimatedApiCallsPerIpn;
      this.TextForCompleteUpload = `Importing ${noOfIpnsImported} of ${(array.length)} `;
      this.cdr.detectChanges();
    });

    this.resetActivityForNewIpn(array[currentIpnImporting]);

    if (array[currentIpnImporting].length != this.IPN_REQUIRED_LENGTH) {
      this.updateActivityIndicator();
      this.updateApiProgress();
      this.setErrorStatus(
        `IPN validation failed: ${array[currentIpnImporting]}`,
        'warning',
        'IPN length must be 7 characters'
      );
      this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": 'IPN length is not 7' });
      localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
      ipnInError++;
      this.ipnInError = ipnInError;
      this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
      localStorage.setItem("ipnInError", ipnInError);
      if (currentIpnImporting < array.length - 1) {
        if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
          setTimeout(() => {
            currentIpnImporting++;
            this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
          }, this.IMPORT_BATCH_DELAY_MS);
        } else {
          currentIpnImporting++;
          this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
        }
      } else {
        this.importCompleted = true
      }
    } else {
      this.updateActivityIndicator();
      this.trackApi(
        this.ArcaService.getPerson(`${this.Config.ApiArcaURL}Person('${array[currentIpnImporting]}')`),
        'getPerson'
      ).subscribe((data: any) => {
        this.updateActivityIndicator();
        if (data != null) {
          let ipnData = '';
          ipnData = data;
          
          if (!data['Mail'] || data['Mail'] === '' || data['Mail'] === undefined || data['Mail'] === null) {
            const errorMsg = `The IPN ${array[currentIpnImporting]} has no email address in ARCA`;
            this.setErrorStatus(
              `Missing email address for IPN: ${array[currentIpnImporting]}`,
              'warning',
              errorMsg
            );
            this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": errorMsg });
            localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
            ipnInError++;
            this.ipnInError = ipnInError;
            this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
            localStorage.setItem('ipnInError', ipnInError.toString());
            
            if (currentIpnImporting < array.length - 1) {
              if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                setTimeout(() => {
                  currentIpnImporting++;
                  this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                }, this.IMPORT_BATCH_DELAY_MS);
              } else {
                currentIpnImporting++;
                this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
              }
            } else {
              this.importCompleted = true;
            }
            return;
          }
          
          if (data['Phone']) {
            data['Phone'][0] = data['Phone'][0].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim();
          }
          if (data['MobilePhoneNumber']) {
            data['MobilePhoneNumber'][0] = data['MobilePhoneNumber'][0].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim();
          }
          if (data['PersonTypeDescription'] && data['PersonTypeDescription'].toLowerCase() == 'b2b renault supplier') {
            this.updateActivityIndicator(); 
            this.trackApi(
              this.ArcaService.getPerson(`${this.Config.ApiArcaURL}Person('${array[currentIpnImporting]}')/AdministrativeOrganizations`),
              'getAdminOrgs'
            ).subscribe((data1: any) => {
              this.updateActivityIndicator();
              if (data1 != null) {
                let alcor = '';
                let alcorTemp = '';
                data1.forEach(e => {
                  if (e.Type == 'ENTT') {
                    alcorTemp = e.Code;
                    alcor = alcorTemp.slice(-this.ROLE_TYPE_CODE_SLICE_PREFIX);
                  }
                });
                if (alcor != '') {
                  this.updateActivityIndicator();
                  this.trackApi(
                    this.Supplierservice.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&value=${alcor}`),
                    'getCompanyIdentifiers'
                  ).subscribe(data2 => {
                    this.updateActivityIndicator();
                    if (Array.isArray(data2?.['company-identifiers']) && data2['company-identifiers'].length > 0) {
                      const companyId = data2['company-identifiers'][0]['linkedCompanyId'];
                      const allRoles = [];
                      companyData = '';
                      this.updateActivityIndicator();
                      this.trackApi(
                        this.Supplierservice.getCompanies(`${this.Config.ApiSupplierUrl}companies/${companyId}`),
                        'getCompanies'
                      ).subscribe(data3 => {
                        this.updateActivityIndicator();
                        if (data3 != null) {
                          companyData = data3;
                          this.updateActivityIndicator();
                          this.trackApi(
                            this.ArcaService.getgroup(`${this.Config.ApiArcaURL}Group?$filter=(GroupsSetDomain eq 'GCF' or GroupsSetDomain eq 'FRA') and (GroupsSetId eq 'Purchasing Supplier Contacts' or GroupsSetId eq 'GROUPES ADF' or GroupsSetId eq 'GROUPES ADF - V2') and Uid eq '${array[currentIpnImporting]}'`),
                            'getGroup'
                          ).subscribe(async (data4: any) => {
                            this.updateActivityIndicator();
                            this.grpData = data4;
                            if (data4 != null) {
                              try {
                                if (data4['value']) {
                                  data4['value'].forEach(e => {
                                    if (e.Description.toLowerCase().includes('adf')) {
                                      allRoles.push('ADF');
                                    } else if (e.Description.toLowerCase().includes('kam')) {
                                      allRoles.push('KAM');
                                    } else if (e.Description.toLowerCase().includes('sales contact')) {
                                      allRoles.push('SAL');
                                    } else if (e.Description.toLowerCase().includes('sales director')) {
                                      allRoles.push('SAD');
                                    } else {
                                    }
                                  });
                                }
                              } catch (error) {
                              }
                            }
                            try {
                              this.updateActivityIndicator();
                              await this.checkForIpnInRfcSync(ipnData, companyData, ipnData['Uid'], allRoles, array[currentIpnImporting]);
                              this.updateApiProgress();
                              this.updateActivityIndicator();
                              await this.ImportfuncRoles(ipnData, array[currentIpnImporting])
                              this.updateApiProgress(); 
                            } catch (error) {
                              const errorMessage = error?.message || error || 'Unexpected error during import';
                              
                              if (errorMessage.includes('has no email address in ARCA')) {
                                this.setErrorStatus(
                                  `Missing email address for IPN: ${array[currentIpnImporting]}`,
                                  'warning',
                                  errorMessage
                                );
                                this.addImportError(array[currentIpnImporting], errorMessage);
                                ipnInError++;
                                this.ipnInError = ipnInError;
                                this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
                                localStorage.setItem('ipnInError', ipnInError.toString());
                                
                                if (currentIpnImporting < array.length - 1) {
                                  if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                                    setTimeout(() => {
                                      currentIpnImporting++;
                                      this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                                    }, this.IMPORT_BATCH_DELAY_MS);
                                  } else {
                                    currentIpnImporting++;
                                    this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                                  }
                                } else {
                                  this.importCompleted = true;
                                }
                                return; 
                              } else {
                                this.setErrorStatus(
                                  `Error during import processing for IPN: ${array[currentIpnImporting]}`,
                                  'critical',
                                  `Error: ${errorMessage}`
                                );
                                return;
                              }
                            }
                            const int = interval(this.PROGRESS_POLL_INTERVAL_MS).subscribe(() => {
                              if (this.imported == true) {
                                this.imported = false
                                noOfIpnsImported++;
                                int.unsubscribe()
                                this.ngZone.run(() => {
                                  this.lastSuccessfulIpn = array[currentIpnImporting];
                                  this.clearErrorStatus(); 
                                  this.noOfIpnsImported = noOfIpnsImported;
                                  this.TextForCompleteUpload = `Importing ${noOfIpnsImported} of ${(array.length)} `;
                                  this.cdr.detectChanges(); 
                                });
                                localStorage.setItem("noOfIpnsImported", noOfIpnsImported);
                                if (currentIpnImporting < array.length - 1) {
                                  if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                                    setTimeout(() => {
                                      currentIpnImporting++;
                                      this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                                    }, this.IMPORT_BATCH_DELAY_MS);
                                  } else {
                                    currentIpnImporting++;
                                    this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                                  }
                                }
                              }
                            })
                          }, async _error => {
                            this.updateActivityIndicator(); 
                            try {
                              await this.checkForIpnInRfcSync(ipnData, companyData, ipnData['Uid'], allRoles, array[currentIpnImporting]);
                              await this.ImportfuncRoles(ipnData, array[currentIpnImporting])
                            } catch (importError) {
                              const errorMessage = importError?.message || importError || 'Unexpected error during import';
                              
                              if (errorMessage.includes('has no email address in ARCA')) {
                                this.setErrorStatus(
                                  `Missing email address for IPN: ${array[currentIpnImporting]}`,
                                  'warning',
                                  errorMessage
                                );
                                this.addImportError(array[currentIpnImporting], errorMessage);
                                ipnInError++;
                                this.ipnInError = ipnInError;
                                this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
                                localStorage.setItem('ipnInError', ipnInError.toString());
                                
                                if (currentIpnImporting < array.length - 1) {
                                  if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                                    setTimeout(() => {
                                      currentIpnImporting++;
                                      this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                                    }, this.IMPORT_BATCH_DELAY_MS);
                                  } else {
                                    currentIpnImporting++;
                                    this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                                  }
                                } else {
                                  this.importCompleted = true;
                                }
                                return; 
                              } else {
                              }
                            }
                            const int = interval(this.PROGRESS_POLL_INTERVAL_MS).subscribe(() => {
                              if (this.imported) {
                                this.imported = false
                                noOfIpnsImported++;
                                int.unsubscribe()
                                this.ngZone.run(() => {
                                  this.lastSuccessfulIpn = array[currentIpnImporting];
                                  this.clearErrorStatus(); 
                                  this.noOfIpnsImported = noOfIpnsImported;
                                  this.TextForCompleteUpload = `Importing ${noOfIpnsImported} of ${(array.length)} `;
                                  this.cdr.detectChanges(); 
                                });
                                localStorage.setItem("noOfIpnsImported", noOfIpnsImported);
                                setTimeout(() => {
                                  if (currentIpnImporting < array.length - 1) {
                                    if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                                      setTimeout(() => {
                                        currentIpnImporting++;
                                        this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                                      }, this.IMPORT_BATCH_DELAY_MS);
                                    } else {
                                      currentIpnImporting++;
                                      this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                                    }
                                  }
                                }, this.IMPORT_COMPLETION_DELAY_MS);
                              }
                            })
                          });
                        } else {
                          this.updateActivityIndicator(); 
                          this.setErrorStatus(
                            `Company not found for IPN: ${array[currentIpnImporting]}`,
                            'warning',
                            `ALCOR code: ${alcor} - Company does not exist in ISA`
                          );
                          this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": `Company${alcor}not found in ISA` });
                          localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
                          ipnInError++;
                          this.ipnInError = ipnInError;
                          this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
                          localStorage.setItem("ipnInError", ipnInError);
                          if (currentIpnImporting < array.length - 1) {
                            if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                              setTimeout(() => {
                                currentIpnImporting++;
                                this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                              }, this.IMPORT_BATCH_DELAY_MS);
                            } else {
                              currentIpnImporting++;
                              this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                            }
                          }
                        }
                      }, error => {
                        this.updateActivityIndicator(); 
                        this.setErrorStatus(
                          `Failed to fetch company data for IPN: ${array[currentIpnImporting]}`,
                          'critical',
                          `Error: ${(error?.message || error?.statusText || 'Network error occurred')}`
                        );
                      });
                    } else {
                      this.updateActivityIndicator(); 
                      this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": `Company ${alcor} not found in ISA` });
                      localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
                      ipnInError++;
                      this.ipnInError = ipnInError;
                      this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
                      localStorage.setItem("ipnInError", ipnInError);
                      if (currentIpnImporting < array.length - 1) {
                        if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                          setTimeout(() => {
                            currentIpnImporting++;
                            this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                          }, this.IMPORT_BATCH_DELAY_MS);
                        } else {
                          currentIpnImporting++;
                          this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                        }
                      } else {
                        this.importCompleted = true
                      }
                    }
                  }, error => {
                    this.updateActivityIndicator(); 
                    this.setErrorStatus(
                      `Failed to fetch company identifiers for IPN: ${array[currentIpnImporting]}`,
                      'critical',
                      `Error: ${(error?.message || error?.statusText || 'Network error occurred')}`
                    );
                  });
                } else {
                  this.updateActivityIndicator(); 
                  if (currentIpnImporting < array.length - 1) {
                    if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                      setTimeout(() => {
                        currentIpnImporting++;
                        this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                      }, this.IMPORT_BATCH_DELAY_MS);
                    } else {
                      currentIpnImporting++;
                      this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                    }
                  } else {
                    this.importCompleted = true
                  }
                }
              } else {
                this.updateActivityIndicator(); 
                this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": 'ALCOR code is empty in ARCA' });
                localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
                ipnInError++;
                this.ipnInError = ipnInError;
                this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
                localStorage.setItem("ipnInError", ipnInError);
                if (currentIpnImporting < array.length - 1) {
                  if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                    setTimeout(() => {
                      currentIpnImporting++;
                      this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                    }, this.IMPORT_BATCH_DELAY_MS);
                  } else {
                    currentIpnImporting++;
                    this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                  }
                } else {
                  this.importCompleted = true
                }
              }
            }, error => {
              this.updateActivityIndicator(); 
              if (error.indexOf(`${this.HTTP_NOT_FOUND_CODE} Not Found`) != -1 || error.indexOf(this.HTTP_NOT_FOUND_CODE) != -1) {
                this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": 'ALCOR code is empty in ARCA' });
                localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
                ipnInError++;
                this.ipnInError = ipnInError;
                this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
                localStorage.setItem("ipnInError", ipnInError);
                if (currentIpnImporting < array.length - 1) {
                  if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                    setTimeout(() => {
                      currentIpnImporting++;
                      this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                    }, this.IMPORT_BATCH_DELAY_MS);
                  } else {
                    currentIpnImporting++;
                    this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                  }
                } else {
                  this.importCompleted = true
                }
              } else {
                this.setErrorStatus(
                  `Failed to fetch administrative organizations for IPN: ${array[currentIpnImporting]}`,
                  'critical',
                  `Error: ${(error?.message || error?.statusText || 'Network error occurred')}`
                );
              }
            });
          } else {
            this.updateActivityIndicator(); 
            this.setErrorStatus(
              `Invalid IPN type: ${array[currentIpnImporting]}`,
              'warning',
              'Only Supplier IPN may be imported'
            );
            this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": 'Only Supplier IPN may be imported' });
            localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
            ipnInError++;
            this.ipnInError = ipnInError;
            this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
            localStorage.setItem("ipnInError", ipnInError);
            if (currentIpnImporting < array.length - 1) {
              if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
                setTimeout(() => {
                  currentIpnImporting++;
                  this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
                }, this.IMPORT_BATCH_DELAY_MS);
              } else {
                currentIpnImporting++;
                this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
              }
            } else {
              this.importCompleted = true
            }
          }
        } else {
          this.updateActivityIndicator(); 
          this.setErrorStatus(
            `IPN not found: ${array[currentIpnImporting]}`,
            'warning',
            'Invalid IPN - person data not found in system'
          );
          this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": 'Invalid IPN' });
          localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
          ipnInError++;
          this.ipnInError = ipnInError;
          this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
          localStorage.setItem("ipnInError", ipnInError);
          if (currentIpnImporting < array.length - 1) {
            if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
              setTimeout(() => {
                currentIpnImporting++;
                this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
              }, this.IMPORT_BATCH_DELAY_MS);
            } else {
              currentIpnImporting++;
              this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
            }
          } else {
            this.importCompleted = true
          }
        }
      }, error => {
        this.updateActivityIndicator(); 
        if (error.indexOf(`${this.HTTP_NOT_FOUND_CODE} Not Found`) != -1 || error.indexOf(this.HTTP_NOT_FOUND_CODE) != -1) {
          this.logFileArrayOfIpns.push({ "ipn": array[currentIpnImporting], "error": 'Invalid IPN' });
          localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
          ipnInError++;
          this.ipnInError = ipnInError;
          this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
          localStorage.setItem("ipnInError", ipnInError);
          if (currentIpnImporting < array.length - 1) {
            if (currentIpnImporting % this.IMPORT_BATCH_SIZE == 0) {
              setTimeout(() => {
                currentIpnImporting++;
                this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
              }, this.IMPORT_BATCH_DELAY_MS);
            } else {
              currentIpnImporting++;
              this.importIpnByFileFunction(array, currentIpnImporting, noOfIpnsImported, ipnInError);
            }
          } else {
            this.importCompleted = true
          }
        } else {
          this.setErrorStatus(
            `Failed to fetch person data for IPN: ${array[currentIpnImporting]}`,
            'critical',
            `Error: ${(error?.message || error?.statusText || 'Network error occurred')}`
          );
        }
      });
    }
    if (currentIpnImporting == array.length - 1) {
      this.TextForCompleteUpload = `Imported ${noOfIpnsImported} of ${(array.length)}.`;
      if (ipnInError > 0) {
        this.TextForIpnInError = `Number of Ipn in error ${ipnInError}`;
      }
      const int = interval(this.PROGRESS_POLL_INTERVAL_MS).subscribe(() => {
        const finalErrorCount = parseInt(localStorage.getItem("ipnInError") || "0");
        const finalImportedCount = Math.min(
          parseInt(localStorage.getItem("noOfIpnsImported") || "0"),
          Math.max(0, array.length - finalErrorCount)
        );
        const totalProcessed = finalImportedCount + finalErrorCount;
        
        const isFullyComplete = this.importCompleted == true && totalProcessed >= array.length;
        
        if (isFullyComplete) {
          this.importCompleted = false
          int.unsubscribe()
          
          
          this.ngZone.run(() => {
            this.showDownloadLog = true;
            this.loadingNoOfIpnsImported = false;
            this.currentIpnImporting = null;
            this.noOfIpnsImported = null;
            this.ipnInError = null;
            this.currentIpnBeingProcessed = '';
            this.currentActionCount = 0;
            this.activitySpinner = this.spinnerChars[0];
            this.ipnTextDisplay = '';
            this.clearErrorStatus();
            if (finalErrorCount === 0) {
              this.TextForCompleteUpload = `✓ Successfully imported all ${finalImportedCount} IPNs!`;
            } else {
              this.TextForCompleteUpload = `Completed: ${finalImportedCount} imported, ${finalErrorCount} errors.`;
            }
            this.cdr.detectChanges(); 
          });
        }
      })
    }
  }

  refreshPage() {
    window.location.reload();
  }
  refreshPagenew() {
    window.location.reload();
  }

  checkForIpnInRfc(ipnData, companyData, ipn, allRoles, ipnToImport) {
    if (ipn != '') {
      let personRowId = '';
      const allAddressData: any = [];
      let ipnUpdateId = '';
      this.contactsservice.getUsers(`${this.Config.ApinewContactsUrl}users?loginId=${ipnToImport}`).subscribe(data => {
        if (data['users'].length > 0) {
          personRowId = data['users'][0]['personRowId'];
          ipnUpdateId = data['users'][0]['rowId'];
          this.getAllAddressData(1, personRowId, ipnUpdateId, companyData, allRoles, ipnData);
        } else {
          if (ipnData['Mail'] != '') {
            this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=${ipnData['Mail']}`).subscribe(data1 => {
              if (data1['personAddresses'].length > 0) {
                personRowId = data1['personAddresses'][0]['personRowId'];
                this.getAllAddressData(1, personRowId, ipnUpdateId, companyData, allRoles, ipnData);
                if (ipnData['Uid'] != '') {
                  const datas =
                  {
                    "loginId": ipnData['Uid'],
                    "loginType": "RENAULT_IPN",
                    "personRowId": personRowId
                  };
                  this.contactsservice.createUsers(`${this.Config.ApinewContactsUrl}users`, datas).subscribe(_data => {

                  });
                }
              } else {
                this.createNewContact(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles);
              }
            });
          } else {
            this.importInvalidText = 'Invalid IPN';
            this.importIpnInvalidError = true;
            this.disableIpnBtn = false;
          }
        }
      });
    }
  }

  getAllAddressData(page = 1, personRowId, ipnUpdateId, companyData, allRoles, ipnData, allAddressData = []) {
    this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=${personRowId}&_page=${page}`).subscribe(data2 => {
      if (data2['personAddresses'].length > 0) {
        data2['personAddresses'].forEach(ele => {
          if (ele.addressType.toLowerCase() == 'telephone') {
            if (allAddressData[ele.addressType] == undefined) {
              allAddressData[ele.addressType] = [];
            }
            allAddressData[ele.addressType].push(ele);
          } else {
            allAddressData[ele.addressType] = ele;
          }
        });
        if (data2['maxPage'] > 1 && data2['maxPage'] != page) {
          this.getAllAddressData(page + 1, personRowId, ipnUpdateId, companyData, allRoles, ipnData, allAddressData);
        } else if (data2['maxPage'] == page) {
          this.updatePersonData(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles);
        } else {
        }
      } else {
        this.createNewContact(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles);
      }
    });
  }

  updatePersonData(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles) {
    const updateNames =
    {
      personFirstName: ipnData['FirstName'],
      personLastName: ipnData['LastName']
    }
    this.contactsservice.updatePersons(`${this.Config.ApinewContactsUrl}persons/${personRowId}`, updateNames).subscribe(_data => {

    });
    const emailUpdate =
    {
      email: ipnData['Mail']
    }
    this.contactsservice.updateEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${allAddressData['EMAIL']['addressId']}`, emailUpdate).subscribe(_data1 => {
    });
    const updates: any = [];
    let phoneUpdate1;
    let phoneUpdate2;
    const updatePhone: any = [];

    if (allAddressData['TELEPHONE']) {
      for (let i = 0; i < allAddressData['TELEPHONE'].length; i++) {
        let addsplit = allAddressData['TELEPHONE'][i].summary.split("*");
        if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "f") {
          if (ipnData['Phone']) {
            for (let j = 0; j < ipnData['Phone'].length; j++) {
              updates[j] = ipnData['Phone'][j].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim();
            }
            phoneUpdate1 =
            {
              phoneNumber: updates[0]
            }
            this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`, phoneUpdate1).subscribe(_data1 => {

            });
          } else {
            this.contactsservice.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`).subscribe(_data => {

            });
          }
        }
        if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "p") {
          if (ipnData['MobilePhoneNumber']) {
            for (let j = 0; j < ipnData['MobilePhoneNumber'].length; j++) {
              updatePhone[j] = ipnData['MobilePhoneNumber'][j].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim();
            }
            phoneUpdate2 =
            {
              phoneNumber: updatePhone[0]
            }
            this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`, phoneUpdate2).subscribe(_data1 => {

            });
          } else {
            this.contactsservice.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`).subscribe(_data => {

            });
          }
        }
      }
    }
    this.updateCheckIPNRoles(ipnData, personRowId, ipnUpdateId, companyData, allRoles);
  }

  updateCheckIPNRoles(ipnData, personRowId, ipnUpdateId, companyData, allRoles = [], page = 1, multiRoleUpdate = [], archiveObj = [], subscribeData = []) {
    if (allRoles.length > 0) {
      this.contactsservice.getPersonRoles(`${this.Config.ApinewContactsUrl}personRoles?personRowId=${personRowId}&_page=${page}`).subscribe(data => {
        if (data['personRoles'].length > 0) {
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            data['personRoles'].forEach(e => {
              subscribeData.push(e);
            });
            this.updateCheckIPNRoles(ipnData, personRowId, ipnUpdateId, companyData, allRoles, page + 1, multiRoleUpdate, archiveObj, subscribeData);
          } else if (data['maxPage'] == page) {
            let anotherRoleExist: any = false;
            subscribeData.forEach(roleObj => {
              const roleRCF = roleObj.roleTypeCode.toLowerCase();
              if (allRoles.indexOf(roleObj.roleTypeCode) == -1) {
                archiveObj.push(roleObj.rowId);
              }
              allRoles.forEach(e => {
                if (roleRCF == e.toLowerCase()) {
                } else {
                  anotherRoleExist = true;
                  multiRoleUpdate.push(e);
                }
              });
            });
            if (anotherRoleExist == true) {
              multiRoleUpdate.forEach(e => {
                this.createNewRoleContact(personRowId, e, companyData, ipnData['Uid']);
              });
            }
            const archiveDate = { endDate: this.commonService.getTodayDate() }
            archiveObj.forEach(_e => {
              this.contactsservice.updatePersonRoles(`${this.Config.ApinewContactsUrl}personRoles/`, archiveDate).subscribe(_data => {

              });
            });
          } else {
          }
        } else {
          allRoles.forEach(e => {
            this.createNewRoleContact(personRowId, e, companyData, ipnData['Uid']);
          });
        }
      });
    } else if (allRoles.length == 0) {
      allRoles.push('DCC');
      this.contactsservice.getPersonRoles(`${this.Config.ApinewContactsUrl}personRoles?personRowId=${personRowId}&_page=${page}`).subscribe(data1 => {
        if (data1['personRoles'].length > 0) {
          if (data1['maxPage'] > 1 && data1['maxPage'] != page) {
            data1['personRoles'].forEach(e => {
              subscribeData.push(e);
            });
            this.updateCheckIPNRoles(ipnData, personRowId, ipnUpdateId, companyData, allRoles, page + 1, multiRoleUpdate, archiveObj, subscribeData);
          } else if (data1['maxPage'] == page) {
            let otherRolesExist = false;
            subscribeData.forEach(roleObj => {
              if (roleObj.roleTypeCode.toLowerCase() == 'sal') {
                roleObj.roleTypeCode = 'sales contact';
              }
              if (this.allowedRoles.indexOf(roleObj.roleTypeCode.toLowerCase()) != -1) {
                this.contactsservice.deletePersonRoles(`${this.Config.ApinewContactsUrl}personRoles/${roleObj.rowId}`).subscribe(_data2 => {

                });
              } else if (this.allowedRoles.indexOf(roleObj.roleTypeCode.toLowerCase()) == -1) {
                otherRolesExist = true;
              } else {
              }
            });
            if (otherRolesExist == false) {
              this.createNewRoleContact(personRowId, 'DCC', companyData, ipnData['Uid']);
            }
          } else {
          }
        } else {
          this.createNewRoleContact(personRowId, 'DCC', companyData, ipnData['Uid']);
        }
      });
    } else {
    }
  }

  createNewRoleContact(personRowId, role, companyData, ipn) {
    if (role.toLowerCase() == 'sales contact') {
      role = 'SAL';
    }
    const newCompanyLink =
    {
      personRowId: personRowId,
      startDate: this.commonService.getTodayDate(),
      personSupplierCompany: `CtcSupplierCompanyService:${companyData['rowId']}`,
      personRoleStatus: 'VALIDATED',
      roleTypeCode: role,
      roleTypeId: this.roleTypeDesc[role].rowId
    }
    this.contactsservice.createSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles`, newCompanyLink).subscribe(_data2 => {

    });
    this.ArcaService.getPerson(`${this.Config.ApiArcaURL}Person('${ipn}')/FunctionalOrganizations`).subscribe((functionalOrgsData: any) => {
      if (functionalOrgsData != null) {
        const allCompanies = [];
        this.functionalCompanyIds = [];
        functionalOrgsData.forEach(ele => {
          if (ele.Type.toLowerCase() == 'site') {
            const alcorTemp = ele.Code;
            allCompanies.push(`'${(alcorTemp.slice(-this.FUNCTIONAL_ORG_COMPANY_SLICE_SIZE)).slice(0, this.FUNCTIONAL_ORG_COMPANY_CODE_LENGTH)}'`);
          }
        });
        this.Supplierservice.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&value=in(${allCompanies})`).subscribe(companyIdenData => {
          if (Array.isArray(companyIdenData?.['company-identifiers']) && companyIdenData['company-identifiers'].length > 0) {
            companyIdenData['company-identifiers'].forEach(ele => {
              if (this.functionalCompanyIds.indexOf(ele.linkedCompanyId) == -1) {
                this.functionalCompanyIds.push(ele.linkedCompanyId);
              }
            });
          }
        });
        if (this.functionalCompanyIds.length > 0) {
          this.functionalCompanyIds.forEach(element => {
            const newCompanyLink =
            {
              personRowId: personRowId,
              startDate: this.commonService.getTodayDate(),
              personSupplierCompany: `CtcSupplierCompanyService:${element}`,
              personRoleStatus: 'VALIDATED',
              roleTypeCode: role,
              roleTypeId: this.roleTypeDesc[role].supplierGroupRoles
            }
            this.contactsservice.createSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles`, newCompanyLink).subscribe(_data2 => {

            });
          });
        }
      }
    });
  }

  createNewContact(ipnData, _personRowId, ipnUpdateId, _allAddressData, companyData, allRoles) {
    const createNames =
    {
      personFirstName: ipnData['FirstName'],
      personLastName: ipnData['LastName']
    }
    const updates: any = [];
    const updatePhone: any = [];
    const createEmail =
    {
      email: ipnData['Mail']
    }
    this.contactsservice.createPersons(`${this.Config.ApinewContactsUrl}persons`, createNames).subscribe(data => {
      const personIdNew = data['rowId'];
      const newIpnCreate =
      {
        "loginId": ipnData['Uid'],
        "loginType": "RENAULT_IPN",
        "personRowId": personIdNew
      }
      this.contactsservice.createUsers(`${this.Config.ApinewContactsUrl}users`, newIpnCreate).subscribe(_data2 => {

      });
      this.contactsservice.createUsers(`${this.Config.ApinewContactsUrl}emailAddresses`, createEmail).subscribe(data12 => {
        const udpateEmail = {
          "personRowId": personIdNew,
          "addressType": "EMAIL",
          "addressIdentifier": data12['identifier'],
          "summary": data12['email'],
          "addressId": data12['supplierGroupRoles']
        }
        this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpateEmail).subscribe(_data1 => {

        });
      });
      if (ipnData['Phone']) {
        for (let i = 0; i < ipnData['Phone'].length; i++) {
          updates[i] = ipnData['Phone'][i];
        }
        const phoneUpdate1 =
        {
          phoneType: 'F',
          phoneNumber: updates[0]
        }
        this.contactsservice.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, phoneUpdate1).subscribe(data21 => {
          const udpatePhone = {
            "personRowId": personIdNew,
            "addressType": "TELEPHONE",
            "addressId": data21['supplierGroupRoles']
          }
          this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpatePhone).subscribe(_data1 => {

          });
        });
      }
      if (ipnData['MobilePhoneNumber']) {
        for (let i = 0; i < ipnData['MobilePhoneNumber'].length; i++) {
          updatePhone[i] = ipnData['MobilePhoneNumber'][i]
        }
        const cellPhoneUpdate1 =
        {
          phoneType: 'P',
          phoneNumber: updatePhone[0]
        }
        this.contactsservice.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, cellPhoneUpdate1).subscribe(data31 => {
          const udpatePhone = {
            "personRowId": personIdNew,
            "addressType": "TELEPHONE",
            "addressId": data31['supplierGroupRoles']
          }
          this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpatePhone).subscribe(_data1 => {

          });
        });
      }
      this.updateCheckIPNRoles(ipnData, personIdNew, ipnUpdateId, companyData, allRoles);
    });
  }

  editContactFn(nameData, emailData, ipnData, cpyData, roleData) {
    this.contactFirstName = '';
    this.contactLastName = '';
    this.contactEmail = '';
    this.contactIpn = '';
    this.contactRole = '';
    this.contactCompany = '';
    this.contactPhone = '';
    this.contactCellphone = '';
    this.rowIdsEditObj = {};
    this.CmpConIpnError = false;
    this.CmpConEmailError = false;
    this.CmpConCellphoneError = false;
    this.CmpConCellphoneError2 = false;
    this.CmpConPhoneError = false;
    this.CmpConPhoneError2 = false;
    this.contactFirstNameError = false;
    this.contactLastNameError = false;
    this.originalContactData = {};
    this.disableEditContactSaveBtn = false;
    this.CmpConCellphoneError2 = false;
    this.CmpConPhoneError2 = false;
    this.disableContactRoleEdit = false;
    this.CmpConRoleError = false;
    const personRowId = nameData.personRowId;
    this.delConRowId = nameData.personRowId;
    if (nameData != undefined) {
      this.contactFirstName = nameData.personFirstName;
      this.contactLastName = nameData.personLastName;
    }
    if (emailData != undefined) {
      this.contactEmail = emailData.summary;
    }
    let cellPhoneRow;
    let phoneRow;
    if (this.allAddressDataContact[personRowId]) {
      this.allAddressDataContact[personRowId].forEach(e => {
        if (e.addressType == 'TELEPHONE') {
          const addSplit = e.summary.split('*');
          if (addSplit.length > 1) {
            if (addSplit[1].toLowerCase().trim() == "f") {
              phoneRow = e.addressId;
              this["contactPhone"] = addSplit[0].trim();
            }
            if (addSplit[1].toLowerCase().trim() == "p") {
              cellPhoneRow = e.addressId;
              this["contactCellphone"] = addSplit[0].trim();
            }
          }
        }
      });
    }
    let ipnRow;
    if (ipnData != undefined) {
      this.contactIpn = ipnData.loginId;
      ipnRow = ipnData.supplierGroupRoles;
    }
    if (cpyData != undefined) {
      this.contactCompany = cpyData.legalName;
    }
    if (roleData != undefined) {
      this.contactRole = roleData.supplierGroupRoles;
      if (ipnData) {
        if (['KAM', 'SAL', 'ADF', 'SAD'].indexOf(roleData.code) == -1) {
          this.disableContactRoleEdit = false;
        }
        else {
          this.disableContactRoleEdit = true;
        }
      } else { this.disableContactRoleEdit = false; }
    }
    this.originalContactData =
    {
      'personFirstName': nameData.personFirstName,
      'personLastName': nameData.personLastName,
      'email': emailData.summary,
      'phone': this["contactPhone"],
      'cellPhone': this["contactCellphone"],
      'ipn': this["contactIpn"]
    }
    this.rowIdsEditObj =
    {
      'nameEdit': nameData.rowId,
      'emailEdit': emailData.addressId,
      'cellphoneEdit': cellPhoneRow,
      'phoneEdit': phoneRow,
      'ipnEdit': ipnRow
    }
  }

  addEditContactDetails() {
    if (this.contactFirstNameError == false && this.contactLastNameError == false && this.CmpConEmailError == false && this.CmpConIpnError == false && this.CmpConCellphoneError == false && this.CmpConPhoneError == false && this.CmpConCellphoneError2 == false && this.CmpConPhoneError2 == false && this.CmpConRoleError == false) {
      this.disableEditContactSaveBtn = true;
      this.contactDetailChanged = false;
      this.counterObj = { 'name': 'notdone', 'email': 'notdone', 'phone': 'notdone', 'cellphone': 'notdone', 'role': 'notdone' }
      const personRowId = this.rowIdsEditObj['nameEdit'];
      if (this.originalContactData['personFirstName'] != this.contactFirstName || this.originalContactData['personLastName'] != this.contactLastName) {
        this.contactDetailChanged = true;
        const nameUpdate = { 'personFirstName': this.contactFirstName, 'personLastName': this.contactLastName }
        this.contactsservice.updatePersons(`${this.Config.ApinewContactsUrl}persons/${personRowId}`, nameUpdate).subscribe(_data => {
          this.counterObj['name'] = 'done';
          this.reloadCounterEdit();
        });
      } else {
        this.counterObj['name'] = 'done';
        this.reloadCounterEdit();
      }
      if (this.originalContactData['email'] != this.contactEmail) {
        this.contactDetailChanged = true;
        const rowId = this.rowIdsEditObj['emailEdit'];
        const emailUpdate = { 'email': this.contactEmail }
        this.contactsservice.updateEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${rowId}`, emailUpdate).subscribe(_data => {
          this.counterObj['email'] = 'done';
          this.reloadCounterEdit();
        });
      } else {
        this.counterObj['email'] = 'done';
        this.reloadCounterEdit();
      }
      if (this.originalContactData['phone'] != this.contactPhone) {
        this.contactDetailChanged = true;
        if (this.rowIdsEditObj['phoneEdit'] != undefined && this.rowIdsEditObj['phoneEdit'] != '') {
          const rowId = this.rowIdsEditObj['phoneEdit'];
          const phoneUpdate = { 'phoneNumber': this.contactPhone.replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim() }
          this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${rowId}`, phoneUpdate).subscribe(_data => {
            this.counterObj['phone'] = 'done';
            this.reloadCounterEdit();
          });
        } else {
          const phoneUpdate1 =
          {
            phoneType: 'F',
            phoneNumber: this.contactPhone.replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim()
          }
          this.contactsservice.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, phoneUpdate1).subscribe(data21 => {
            const udpatePhone = {
              "personRowId": personRowId,
              "addressType": "TELEPHONE",
              "addressId": data21['supplierGroupRoles']
            }
            this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpatePhone).subscribe(_data1 => {
              this.counterObj['phone'] = 'done';
              this.reloadCounterEdit();
            });
          });
        }
      } else {
        this.counterObj['phone'] = 'done';
        this.reloadCounterEdit();
      }
      if (this.originalContactData['cellPhone'] != this.contactCellphone) {
        this.contactDetailChanged = true;
        if (this.rowIdsEditObj['cellphoneEdit'] != undefined && this.rowIdsEditObj['cellphoneEdit'] != '') {
          const rowId = this.rowIdsEditObj['cellphoneEdit'];
          const cellPhoneUpdate = { 'phoneNumber': this.contactCellphone.replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim() }
          this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${rowId}`, cellPhoneUpdate).subscribe(_data => {
            this.counterObj['cellphone'] = 'done';
            this.reloadCounterEdit();
          });
        } else {
          const phoneUpdate1 =
          {
            phoneType: 'P',
            phoneNumber: this.contactCellphone.replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim()
          }
          this.contactsservice.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, phoneUpdate1).subscribe(data21 => {
            const udpatePhone = {
              "personId": personRowId,
              "addressType": "TELEPHONE",
              "addressId": data21['supplierGroupRoles']
            }
            this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpatePhone).subscribe(_data1 => {
              this.counterObj['cellphone'] = 'done';
              this.reloadCounterEdit();
            });
          });
        }
      } else {
        this.counterObj['cellphone'] = 'done';
        this.reloadCounterEdit();
      }
      if (this.originalContactData['role'] != this.contactRole) {
        this.contactDetailChanged = true;
        const rowId = this.rowIdsEditObj['nameEdit'];
        const roleUpdate = { roleTypeId: this.contactRole }
        this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${rowId}`, roleUpdate).subscribe(_data => {
          this.counterObj['role'] = 'done';
          this.reloadCounterEdit();
        });
      } else {
        this.counterObj['role'] = 'done';
        this.reloadCounterEdit();
      }
    }
  }

  reloadCounterEdit() {
    if
      (
      this.counterObj['name'] == 'done' &&
      this.counterObj['email'] == 'done' &&
      this.counterObj['phone'] == 'done' &&
      this.counterObj['cellphone'] == 'done' &&
      this.counterObj['role'] == 'done') {
      document.getElementById('closeEditCmpConRole').click();
      document.getElementById('closeopenEditNameFields').click();
      if (this.contactDetailChanged == true) {
        this.clearFields('All');
        this.firstName = this.contactFirstName;
        this.LastName = this.contactLastName;
        this.getSearch();
      }
    }
  }

  resetNameErrors() {
    this.contactFirstNameError = false;
    this.contactLastNameError = false;
  }

  resetNameValues() {
    this.contactFirstName = this.originalContactData['personFirstName'];
    this.contactLastName = this.originalContactData['personLastName'];
  }

  contactEmptyCheck(model, check = '') {
    const value = this[model];
    if (/^\s/.test(value)) {
      this[model] = value.trimStart();
      return false;
    }
    const errorModel = this.errorModelOnNgModel[model];
    if (value.length == 0) {
      this[errorModel] = true;
    } else {
      this[errorModel] = false;
    }
    if (check == 'numCheck') {
      const modelRegEx = this.errorRegExModel[model];
      if (!value.match(/^[ 0-9\+\-]*$/gm)) {
        this[modelRegEx] = true;
      } else {
        this[modelRegEx] = false;
      }
    }
  }

  resetCmpContact(model) {
    this[model] = '';
    const errorModel = this.errorModelOnNgModel[model];
    this[errorModel] = true;
    const modelRegEx = this.errorRegExModel[model];
    this[modelRegEx] = false;
  }

  CmpCntRoleSelected(event: any) {
    this.contactRole = event.target.value;
    if (this.contactRole != undefined && this.contactRole != "") {
      this["CmpConRoleError"] = false;
    } else {
      this["CmpConRoleError"] = true;
    }
  }

  delContact() {
    if (this.delConRowId != "") {
      if (this.rowIdsEditObj['ipnEdit'] != undefined && this.rowIdsEditObj['ipnEdit'] != '') {
        this.contactsservice.deleteusers(`${this.Config.ApinewContactsUrl}users/${this.rowIdsEditObj['ipnEdit']}`).subscribe(_data => { });
      }
      this.contactsservice.deletePersons(`${this.Config.ApinewContactsUrl}persons/${this.delConRowId}`).subscribe((_data: any) => {
        this.contactsservice.deleteEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${this.rowIdsEditObj['emailEdit']}`).subscribe(_data => { });
        if (this.rowIdsEditObj['phoneEdit'] != undefined && this.rowIdsEditObj['phoneEdit'] != '') {
          this.contactsservice.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${this.rowIdsEditObj['phoneEdit']}`).subscribe(_data => { });
        }
        if (this.rowIdsEditObj['cellphoneEdit'] != undefined && this.rowIdsEditObj['cellphoneEdit'] != '') {
          this.contactsservice.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${this.rowIdsEditObj['cellphoneEdit']}`).subscribe(_data => { });
        }
        this.contactsservice.deleteSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles/${this.rowIdsEditObj['nameEdit']}`).subscribe(_data => { });
        this.clearFields('All');
        this.getSearch();
        window.document.getElementById("DeleteContact").click();
        window.document.getElementById("closeEditCmpConRole").click();
        window.document.getElementById("closeContactDetails").click();
      });
    }
  }

  getRoleTypes(page = 1, onLoad = true, subscribedata = []) {
    if (onLoad) {
      this.PersonRoleSelectOp = []
      this.roleTypesData = []
    }
    this.contactsservice.getPersonRoleTypes(`${this.Config.ApinewContactsUrl}personRoleTypes?_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
      if (data['personRoleTypes'].length > 0) {
        data['personRoleTypes'].forEach(e => {
          this.roleTypeDesc[e.roleTypeCode] = e;
          if (e.categoryCode.toLowerCase() == this.roleCategory) {
            this.PersonRoleSelectOp.push({ "rowId": e.rowId, "roleTypeCode": e.roleTypeCode, "roleTypeLabel": e.roleTypeLabel });
          }
          subscribedata.push(e)
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getRoleTypes(page + 1, false, subscribedata);
        } else {
          this.roleTypesData = subscribedata
        }
      }
    });
  }

  autoCmpIpnVals(_value, page = 1) {
    const ipnValue = this.ipnModel.trim();
    this.ipnModelDropDown = [];
    if (this.identifierTypeModel == 'ipn') {
      if (ipnValue.length > this.MIN_IPN_SEARCH_LENGTH) {
        this.autoload = true
        this.contactsservice.getUsers(`${this.Config.ApinewContactsUrl}users?loginId=*${ipnValue}*&loginType=RENAULT_IPN&_page=${page}&_pagesize=${this.maxRecorePage}`).subscribe(data => {
          if (data['users'].length > 0) {
            data['users'].forEach(e => {
              this.ipnModelDropDown.push(e.loginId);
            });
          }
          this.autoload = false
        });
      }
    } else {
      if (ipnValue.length > this.MIN_IPN_SEARCH_LENGTH) {
        this.autoload = true
        this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=*${ipnValue.replaceAll('*', '%2A')}*&_page=${page}`).subscribe(data => {
          if (data['personAddresses'].length > 0) {
            this.autoload = true
            data['personAddresses'].forEach(e => {
              this.ipnModelDropDown.push(e.summary);
            });
          }
          this.autoload = false
        })
      }
    }
  }

  onIdentivalueSelect(selected) {
    if (selected) {
      this.ipnModel = selected;
    }
  }

  selectChangeHandler(event: any) {
    if (event.value == 'role') {
      this.roleDropdown = true;
    }
    else {
      this.roleDropdown = false;
    }
    this.loadData = false
  }

  selectedRoleChange(event: any) {
    this.selectedRole = event.value;
    this.userRoleData = []
    this.pager = this.pagerService.getPager(0, 1, 1)
    this.loadData = false
  }
  async apicall(url) {
    try {
      return await url
    } catch (err) {

    }
  }

  async getRoleSearch(page) {
    this.maxRecorePage = this.ROLE_SEARCH_MAX_RECORDS_PAGE
    this.loading = true
    this.loadData = true
    if (this.roleCategory == 'group contact') {
      let grpId: any;
      const groupIds = []
      const personsIds = []
      let data: any
      if (this.selectedRole != '') {
        data = await this.apicall(firstValueFrom(this.contactsservice.getSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles?roleTypeCode=${this.selectedRole}&_page=${page}`)))
      } else {
        data = await this.apicall(firstValueFrom(this.contactsservice.getSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles?_page=${page}`)))
      }
      if (data['supplierGroupRoles'].length > 0) {
        data['supplierGroupRoles'].forEach(e => {
          if (e.supplierGroup) {
            if (typeof e.supplierGroup === 'string') {
              grpId = e.supplierGroup.split(':');
              groupIds.push(grpId[1]);
            } else {
              grpId = e.supplierGroup.href.split('/');
              groupIds.push(grpId[1]);
            }
            personsIds.push(e.personRowId)
          }
          this.userRoleData.push(e)
          if (this.userGroupData[e.personRowId] == undefined) {
            this.userGroupData[e.personRowId] = [];
          }
          if (this.userGroupData[e.personRowId][e.rowId] == undefined) {
            this.userGroupData[e.personRowId][e.rowId] = [];
          }
          let groupId
          if (typeof e.supplierGroup === 'string') {
            grpId = e.supplierGroup.split(':');
            groupId = grpId[1]
          } else {
            grpId = e.supplierGroup.href.split('/');
            groupId = grpId[1]
          }
          this.userGroupData[e.personRowId][e.rowId] = e;
          this.userGroupData[e.personRowId][e.rowId].groupId = groupId
        })
        this.pager = this.pagerService.getPager(data['count'], data['page'], this.ROLE_SEARCH_MAX_RECORDS_PAGE);
        this.PageTotalLength = data['count'];
        if (data['pageCount'] <= this.PAGE_COUNT_THRESHOLD) {
          this.pageHeight = data['pageCount'] * this.PAGE_HEIGHT_ROLE_ROW_FACTOR + this.PAGE_HEIGHT_BASE_OFFSET;
        } else {
          this.pageHeight = this.PAGE_HEIGHT_FALLBACK;
        }
        this.getGroupsList(groupIds)
        this.sortGetData(page, personsIds, 'role');
      } else {
        this.loadData = true;
        this.loading = false;
      }
    } else if (this.roleCategory == 'company contact') {
      const companyId = []
      const personsIds = []
      let data: any
      if (this.selectedRole != '') {
        data = await this.apicall(firstValueFrom(this.contactsservice.getSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles?roleTypeCode=${this.selectedRole}&_page=${page}`)))
      } else {
        data = await this.apicall(firstValueFrom(this.contactsservice.getSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles?_page=${page}`)))
      }
      if (data['supplierCompanyRoles'].length > 0) {
        data['supplierCompanyRoles'].forEach(e => {
          if (e.personRoleStatus.toLowerCase() != 'archived') {
            let cpyId: any;
            if (e.personSupplierCompany) {
              if (typeof e.personSupplierCompany === 'string') {
                cpyId = e.personSupplierCompany.split(":");
              } else {
                cpyId = e.personSupplierCompany.href.split("/");
              }
              companyId.push(cpyId[1])
              personsIds.push(e.personRowId)
              this.userRoleData.push(e)
            }
            if (this.userCompanyData[e.personRowId] == undefined) {
              this.userCompanyData[e.personRowId] = [];
            }
            if (this.userCompanyData[e.personRowId][e.rowId] == undefined) {
              this.userCompanyData[e.personRowId][e.rowId] = [];
            }
            this.userCompanyData[e.personRowId][e.rowId] = e;
            this.userCompanyData[e.personRowId][e.rowId].companyId = cpyId[1]
            const datas = []
            this.userRoleData.forEach(data => {
              if (data['roleTyperoleTypeCode'] == 'ADF') {
                datas.push(data)
              }
            })
          }
        });
        this.pager = this.pagerService.getPager(data['count'], data['page'], this.ROLE_SEARCH_MAX_RECORDS_PAGE);
        this.PageTotalLength = data['count'];
        if (data['pageCount'] <= this.PAGE_COUNT_THRESHOLD) {
          this.pageHeight = data['pageCount'] * this.PAGE_HEIGHT_ROLE_ROW_FACTOR + this.PAGE_HEIGHT_BASE_OFFSET;
        } else {
          this.pageHeight = this.PAGE_HEIGHT_FALLBACK;
        }
        this.getCompaniesList(companyId)
        this.sortGetData(page, personsIds, 'role');
      } else {
        this.loadData = true;
        this.loading = false;
      }
    } else {
      const siteIds = []
      let companyId = []
      const personsIds = []
      let data: any
      if (this.selectedRole != '') {
        data = await this.apicall(firstValueFrom(this.contactsservice.getSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles?roleTypeCode=${this.selectedRole}&_page=${page}`)))
      } else {
        data = await this.apicall(firstValueFrom(this.contactsservice.getSiteRoles(`${this.Config.ApinewContactsUrl}supplierSiteRoles?_page=${page}`)))
      }
      if (data['supplierSiteRoles'].length > 0) {
        data['supplierSiteRoles'].forEach(e => {
          let siteId;
          if (e.site) {
            if (typeof e.site === 'string') {
              siteId = e.site.split(":");
            } else {
              siteId = e.site.href.split("/");
            }
            siteIds.push(siteId[1]);
            e['siteId'] = siteId[1];
          }
          if (e.personSupplierCompany) {
            if (typeof e.personSupplierCompany === 'string') {
              companyId = e.personSupplierCompany.split(":");
            } else {
              companyId = e.personSupplierCompany.href.split("/");
            }
            companyId.push(companyId[1]);
            e['companyId'] = companyId[1];
          }
          personsIds.push(e.personRowId)
          this.userRoleData.push(e)
          if (this.userSiteData[e.personRowId] == undefined) {
            this.userSiteData[e.personRowId] = [];
          }
          if (this.userSiteData[e.personRowId][e.rowId] == undefined) {
            this.userSiteData[e.personRowId][e.rowId] = [];
          }
          this.userSiteData[e.personRowId][e.rowId] = e;
        })
        this.pager = this.pagerService.getPager(data['count'], data['page'], this.ROLE_SEARCH_MAX_RECORDS_PAGE);
        this.PageTotalLength = data['count'];
        if (data['pageCount'] <= this.PAGE_COUNT_THRESHOLD) {
          this.pageHeight = data['pageCount'] * this.PAGE_HEIGHT_ROLE_ROW_FACTOR + this.PAGE_HEIGHT_BASE_OFFSET;
        } else {
          this.pageHeight = this.PAGE_HEIGHT_FALLBACK;
        }
        this.getSitesList(siteIds)
        this.sortGetData(page, personsIds, 'role');
      } else {
        this.loadData = true;
        this.loading = false;
      }
    }
  }

  changeListener($event) {
    this.readThis($event.target);
    this.fileIsEmpty = false;
  }

  readThis(inputValue: any) {
    this.fileToUpload = inputValue.files[0];
    const allowedFileTypes = ['txt'];
    let ipns = []
    const splits = this.fileToUpload.name.split('.');
    const maxSplitLen = splits.length;
    const extension = splits[maxSplitLen - 1].toLowerCase();
    if (!allowedFileTypes.includes(extension)) {
      this.uploadDocError = true;
    } else {
      this.uploadDocError = false;
    }
    const reader: FileReader = new FileReader();
    reader.readAsText(this.fileToUpload);
    reader.onload = (_e) => {
      const txt: any = reader.result;
      ipns = txt.split(/\r\n/);
      ipns.forEach(ipn => {
        if (ipn != '') {
          this.arrayOfIpnsToImport.push(ipn);
        }
      })
    }
  }

  checkLocalStorage() {
    try {
      const tempIpnsInFileForLocal = JSON.parse(localStorage.getItem('tempIpnsInFileForLocal'));
      const logFileArrayOfIpns = JSON.parse(localStorage.getItem('logFileArrayOfIpns'));
      const currentIpnImporting = localStorage.getItem("currentIpnImporting");
      let noOfIpnsImported = localStorage.getItem("noOfIpnsImported");
      let ipnInError = localStorage.getItem("ipnInError");
      const totalIpnsToImport = localStorage.getItem("totalIpnsToImport");
      
      
      // Validate that we have valid data to resume
      if (currentIpnImporting != null && currentIpnImporting != 'null' && 
          tempIpnsInFileForLocal && Array.isArray(tempIpnsInFileForLocal) && tempIpnsInFileForLocal.length > 0) {
        
        if (noOfIpnsImported == null || noOfIpnsImported == 'null') {
          noOfIpnsImported = '0';
        }
        if (ipnInError == null || ipnInError == 'null') {
          ipnInError = '0';
        }
        if (logFileArrayOfIpns == null || logFileArrayOfIpns == 'null') {
          this.logFileArrayOfIpns = [];
        } else {
          this.logFileArrayOfIpns = logFileArrayOfIpns;
        }
        if (totalIpnsToImport == null || totalIpnsToImport == 'null') {
          this.totalIpnsToImport = '0';
        } else {
          this.totalIpnsToImport = totalIpnsToImport;
        }
        this.importArrayOfIpnsStartFn(tempIpnsInFileForLocal, parseInt(currentIpnImporting), parseInt(noOfIpnsImported), parseInt(ipnInError));
        document.getElementById('btnForImportIpnByFile').click();
      } else {
        // No valid import to resume, clear everything
        this.clearImportLocalStorage();
      }
    } catch (e) {
      // If there's any error parsing localStorage, clear it
      this.clearImportLocalStorage();
    }
  }

  downloadLogFile() {
    const element = document.getElementById('excelTableLog');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Import Ipn By File');
    XLSX.writeFile(wb, 'IpnLogFile.xlsx');
  }

  ValidateMandarotyFields() {
    if (this.identifierTypeModel != 'ipn' && this.identifierTypeModel != 'email') {
      if (this.roleCategory.trim() != "") {
        this.RoleCategoryError = false;
        this.getSearch();
      } else {
        this.getSearch()
      }
    } else {
      this.getSearch();
    }
  }
  onRoleCategorySelect(selected) {
    this.firstName = '';
    this.LastName = '';
    this.ipnModel = '';
    this.selectedRole = ""
    if (selected) {
      this.selectedRoleCategory = selected
      this.RoleCategoryError = false;
    } else {
      this.selectedRoleCategory = "failed";
      this.RoleCategoryError = true;
    }
    this.userRoleData = []
    this.pager = this.pagerService.getPager(0, 1, 1)
    this.loadData = false
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  ImportfuncRoles(ipnData, ipn = '') {
    if (ipn != '') {
      this.importIpnModel = ipn;
    }
    let allFuncRoles = [];
    this.ArcaService.getPerson(`${this.Config.ApiArcaURL}Person('${this.importIpnModel}')/FunctionalOrganizations`).subscribe(async (funcData: any) => {
      if (funcData != null) {
        const data = funcData.filter(x => x.Type.toLowerCase() == 'site')
        for (let index = 0; index < funcData.length; index++) {
          allFuncRoles = [];
          const item = funcData[index];
          if (item && item.Code && item.Code.length == this.FUNCTION_CODE_LENGTH) {
            const code = item.Code.slice(this.COMPANY_CODE_SLICE_PREFIX).slice(0, this.COMPANY_CODE_SLICE_SUFFIX);
            try {
              const raft_alcorCode = await this.handleApiCall(firstValueFrom(this.Supplierservice.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&value=${code}&endDate=is null`)), 'error in getting Company')
              if (Array.isArray(raft_alcorCode?.['company-identifiers']) && raft_alcorCode['company-identifiers'].length > 0) {
                const companyId = raft_alcorCode['company-identifiers'][0]['linkedCompanyId'];
                const cmpData = await this.handleApiCall(firstValueFrom(this.Supplierservice.getCompanies(`${this.Config.ApiSupplierUrl}companies/${companyId}`)))
                if (cmpData != null) {
                  if (this.grpData != null) {
                    this.grpData['value'].forEach(e => {
                      if (e.Description.toLowerCase().includes('adf')) {
                        allFuncRoles.push('ADF');
                      } else if (e.Description.toLowerCase().includes('kam')) {
                        allFuncRoles.push('KAM');
                      } else if (e.Description.toLowerCase().includes('sales contact')) {
                        allFuncRoles.push('SAL');
                      } else if (e.Description.toLowerCase().includes('sales director')) {
                        allFuncRoles.push('SAD');
                      } else {
                      }
                    });
                  }
                  await this.checkForIpnInRfcSync(ipnData, cmpData, ipnData['Uid'], allFuncRoles, this.importIpnModel);
                  if (index == funcData.length - 1) {
                    this.imported = true
                    this.importIpnModel = '';
                    this.disableIpnBtn = false;
                    if (document.getElementById('openImportIpnModal')) {
                      document.getElementById('closeImportIpn').click();
                    }
                    if (localStorage.getItem('currentIpnImporting') != null) {
                      if (this.currentIpnImporting == this.totalIpnsToImport - 1) {
                        this.importCompleted = true
                      }
                    }
                  }
                }
              }
              else {
                if (index == funcData.length - 1) {
                  this.imported = true
                  this.importIpnModel = '';
                  this.disableIpnBtn = false;
                  if (document.getElementById('openImportIpnModal')) {
                    document.getElementById('closeImportIpn').click();
                  }
                  if (localStorage.getItem('currentIpnImporting') != null) {
                    if (this.currentIpnImporting == this.totalIpnsToImport - 1) {
                      this.importCompleted = true
                    }
                  }
                }
              }
            } catch (error) {
              this.setErrorStatus(
                'Error processing roles for IPN',
                'critical',
                `Error: ${(error?.message || error || 'Unexpected error in role processing')}`
              );
              throw error; 
            }
          } else {
            const roleTypeCode = item.Code.slice(this.ROLE_TYPE_CODE_SLICE_PREFIX)
            try {
              const saer_Code = await this.handleApiCall(firstValueFrom(this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}/access-point-identifiers?endDate=is null&identifierValue=${roleTypeCode}&identifierTypeName=SAER_CODE`)))

              if (saer_Code ? saer_Code['access-point-identifiers'].length > 0 : false) {
                const saer_alcorCode = await this.handleApiCall(firstValueFrom(this.Supplierservice.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?reaIdentifier=${saer_Code['access-point-identifiers'][0]['siteIdentifier']}&validityEndDate=is null`)))
                if (saer_alcorCode['site-assignments'].length > 0) {
                  const companyId = saer_alcorCode['site-assignments'][0]['businessEntityCompanyId'];
                  const cmpData = await this.handleApiCall(firstValueFrom(this.Supplierservice.getCompanies(`${this.Config.ApiSupplierUrl}companies/${companyId}`)))
                  if (cmpData != null) {
                    if (this.grpData != null) {
                      this.grpData['value'].forEach(e => {
                        if (e.Description.toLowerCase().includes('adf')) {
                          allFuncRoles.push('ADF');
                        } else if (e.Description.toLowerCase().includes('kam')) {
                          allFuncRoles.push('KAM');
                        } else if (e.Description.toLowerCase().includes('sales contact')) {
                          allFuncRoles.push('SAL');
                        } else if (e.Description.toLowerCase().includes('sales director')) {
                          allFuncRoles.push('SAD');
                        } else {
                        }
                      });
                    }
                    await this.checkForIpnInRfcSync(ipnData, cmpData, ipnData['Uid'], allFuncRoles, this.importIpnModel);
                    if (index == funcData.length - 1) {
                      this.imported = true
                      this.importIpnModel = '';
                      this.disableIpnBtn = false;
                      if (document.getElementById('openImportIpnModal')) {
                        document.getElementById('closeImportIpn').click();
                      }

                    }
                    if (localStorage.getItem('currentIpnImporting') != null) {
                      if (this.currentIpnImporting == this.totalIpnsToImport - 1) {
                        this.importCompleted = true
                      }
                    }
                  }
                }
              }
              else {
                if (index == funcData.length - 1) {
                  this.imported = true
                  this.importIpnModel = '';
                  this.disableIpnBtn = false;
                  if (document.getElementById('openImportIpnModal')) {
                    document.getElementById('closeImportIpn').click();
                  }
                }
                if (localStorage.getItem('currentIpnImporting') != null) {
                  if (this.currentIpnImporting == this.totalIpnsToImport - 1) {
                    this.importCompleted = true
                  }
                }
              }
            } catch (error) {
              this.setErrorStatus(
                'Error processing site roles for IPN',
                'critical',
                `Error: ${(error?.message || error || 'Unexpected error in site role processing')}`
              );
              throw error; 
            }
          }
        }
      } else {
        this.imported = true
        this.importIpnModel = '';
        this.disableIpnBtn = false;
        if (document.getElementById('openImportIpnModal')) {
          document.getElementById('closeImportIpn').click();
        }
        if (localStorage.getItem('currentIpnImporting') != null) {
          if (this.currentIpnImporting == this.totalIpnsToImport - 1) {
            this.importCompleted = true
          }
        }
      }
    }, _err => {
      setTimeout(() => {
        this.imported = true
        this.importIpnModel = '';
        this.disableIpnBtn = false;
        if (document.getElementById('openImportIpnModal')) {
          document.getElementById('closeImportIpn').click();
        }
      }, this.IMPORT_COMPLETION_DELAY_MS)
    })
  }
  async checkForIpnInRfcSync(ipnData, companyData, ipn, allRoles, ipnToImport) {
    if (ipn != '') {
      if (!ipnData['Mail'] || ipnData['Mail'] === '' || ipnData['Mail'] === undefined || ipnData['Mail'] === null) {
        const errorMsg = `The IPN ${ipnToImport} has no email address in ARCA`;
        this.logFileArrayOfIpns.push({ "ipn": ipnToImport, "error": errorMsg });
        localStorage.setItem("logFileArrayOfIpns", JSON.stringify(this.logFileArrayOfIpns));
        throw new Error(errorMsg);
      }
      
      let personRowId = '';
      const allAddressData: any = [];
      let ipnUpdateId = '';
      const rolesExists = []
      try {
        if (this.addressData == null || this.addressData['personAddresses'].length == 0) {
          this.addressData = await this.handleApiCall(firstValueFrom(this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=${ipnData['Mail']}`)))
        } if (this.userData == null || this.userData['users'].length == 0) {
          this.userData = await this.handleApiCall(firstValueFrom(this.contactsservice.getUsers(`${this.Config.ApinewContactsUrl}users?loginId=${ipnToImport}`)))
        }
        if (this.userData ? this.userData['users'].length > 0 : false) {
          const companyroles = await this.handleApiCall(firstValueFrom(this.contactsservice.getSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles?personSupplierCompany=CtcSupplierCompanyService:${companyData['rowId']}&personRowId=${this.userData['users'][0]['personRowId']}&personRoleStatus=VALIDATED&_page=${1}`)))
          if (companyroles ? companyroles['supplierCompanyRoles'].length > 0 : false) {
            companyroles['supplierCompanyRoles'].forEach(e => {
              rolesExists.push(e)
            })
          }
          personRowId = this.userData['users'][0]['personRowId'];
          ipnUpdateId = this.userData['users'][0]['rowId'];
          await this.getAllAddressDataSync(1, personRowId, ipnUpdateId, companyData, allRoles, ipnData, [], rolesExists);
        } else {
          if (ipnData['Mail'] && ipnData['Mail'] != '' && ipnData['Mail'] != undefined) {
            if (this.addressData['personAddresses'].length > 0) {
              personRowId = this.addressData['personAddresses'][0]['personRowId'];
              await this.getAllAddressDataSync(1, personRowId, ipnUpdateId, companyData, allRoles, ipnData);
              if (ipnData['Uid'] != '') {
                const datas =
                {
                  "loginId": ipnData['Uid'],
                  "loginType": "RENAULT_IPN",
                  "personRowId": personRowId
                };
                await this.handleApiCall(firstValueFrom(this.contactsservice.createUsers(`${this.Config.ApinewContactsUrl}users`, datas)))

              }
            } else {
              await this.createNewContactSync(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles);
            }

          } else {
            const errorMsg = `The IPN ${ipnToImport} has no email address in ARCA`;
            this.importInvalidText = errorMsg;
            this.importIpnInvalidError = true;
            this.disableIpnBtn = false;
            throw new Error(errorMsg);
          }
        }
      } catch (e) {
        if (ipnData['Mail'] && ipnData['Mail'] != '' && ipnData['Mail'] != undefined) {
          if (this.addressData['personAddresses'].length > 0) {
            personRowId = this.addressData['personAddresses'][0]['personRowId'];
            await this.getAllAddressDataSync(1, personRowId, ipnUpdateId, companyData, allRoles, ipnData);
            if (ipnData['Uid'] != '') {
              const datas =
              {
                "loginId": ipnData['Uid'],
                "loginType": "RENAULT_IPN",
                "personId": personRowId
              };
              await this.handleApiCall(firstValueFrom(this.contactsservice.createUsers(`${this.Config.ApinewContactsUrl}users`, datas)))

            }
          } else {
            await this.createNewContactSync(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles);
          }

        } else {
          const errorMsg = `The IPN ${ipnToImport} has no email address in ARCA`;
          this.importInvalidText = errorMsg;
          this.importIpnInvalidError = true;
          this.disableIpnBtn = false;
          throw new Error(errorMsg);
        }
      }
    }
  }
  async getAllAddressDataSync(page = 1, personRowId, ipnUpdateId, companyData, allRoles, ipnData, allAddressData = [], rolesExists = []) {
    if (this.alladdressesDatas == false) {
      const data2 = await this.handleApiCall(firstValueFrom(this.contactsservice.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=${personRowId}&_page=${page}`)))
      if (data2['personAddresses'].length > 0) {
        data2['personAddresses'].forEach(ele => {
          if (ele.addressType.toLowerCase() == 'telephone') {
            if (allAddressData[ele.addressType] == undefined) {
              allAddressData[ele.addressType] = [];
            }
            allAddressData[ele.addressType].push(ele);
          } else {
            allAddressData[ele.addressType] = ele;
          }
        });
        if (data2['maxPage'] > 1 && data2['maxPage'] != page) {
          await this.getAllAddressDataSync(page + 1, personRowId, ipnUpdateId, companyData, allRoles, ipnData, allAddressData, rolesExists);
        } else if (data2['maxPage'] == page) {
          this.alladdressesDatas = true
          await this.updatePersonDataSync(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles, rolesExists);
        } else {
        }
      } else {
        await this.createNewContactSync(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles, rolesExists);
      }
    } else {
      await this.updateCheckIPNRolesSync(ipnData, personRowId, ipnUpdateId, companyData, allRoles, 1, [], [], [], rolesExists);
    }

  }

  async updatePersonDataSync(ipnData, personRowId, ipnUpdateId, allAddressData, companyData, allRoles, rolesExists = []) {
    if (this.personUpdated == false) {
      this.personUpdated = true;
      const updateNames =
      {
        personFirstName: ipnData['FirstName'],
        personLastName: ipnData['LastName']
      }
      await this.handleApiCall(firstValueFrom(this.contactsservice.updatePersons(`${this.Config.ApinewContactsUrl}persons/${personRowId}`, updateNames)))
      const emailUpdate =
      {
        email: ipnData['Mail']
      }
      await this.handleApiCall(firstValueFrom(this.contactsservice.updateEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${allAddressData['EMAIL']['addressId']}`, emailUpdate)))

      const updates: any = [];
      let phoneUpdate1;
      let phoneUpdate2;
      const updatePhone: any = [];

      if (allAddressData['TELEPHONE']) {
        for (let i = 0; i < allAddressData['TELEPHONE'].length; i++) {
          let addsplit = allAddressData['TELEPHONE'][i].summary.split("*");
          if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "f") {
            if (ipnData['Phone']) {
              for (let j = 0; j < ipnData['Phone'].length; j++) {
                updates[j] = ipnData['Phone'][j].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim();
              }
              phoneUpdate1 =
              {
                phoneNumber: updates[0]
              }
              await this.handleApiCall(firstValueFrom(this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`, phoneUpdate1)))
            } else {
              await this.handleApiCall(firstValueFrom(this.contactsservice.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`)))
            }
          }
          if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "p") {
            if (ipnData['MobilePhoneNumber']) {
              for (let j = 0; j < ipnData['MobilePhoneNumber'].length; j++) {
                updatePhone[j] = ipnData['MobilePhoneNumber'][j].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim();
              }
              phoneUpdate2 =
              {
                phoneNumber: updatePhone[0]
              }
              await this.handleApiCall(firstValueFrom(this.contactsservice.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`, phoneUpdate2)))
            } else {
              await this.handleApiCall(firstValueFrom(this.contactsservice.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${allAddressData['TELEPHONE'][i]['addressId']}`)))

            }
          }
        }
      }
    }
    await this.updateCheckIPNRolesSync(ipnData, personRowId, ipnUpdateId, companyData, allRoles, 1, [], [], [], rolesExists);
  }
  async createNewContactSync(ipnData, _personRowId, ipnUpdateId, _allAddressData, companyData, allRoles, rolesExists = []) {
    this.personUpdated = true
    this.alladdressesDatas = true
    const createNames =
    {
      personFirstName: ipnData['FirstName'],
      personLastName: ipnData['LastName']
    }
    const updates: any = [];
    const updatePhone: any = [];
    const createEmail =
    {
      email: ipnData['Mail']
    }
    const data = await this.handleApiCall(firstValueFrom(this.contactsservice.createPersons(`${this.Config.ApinewContactsUrl}persons`, createNames)))
    const personIdNew = data['rowId'];
    const newIpnCreate =
    {
      "loginId": ipnData['Uid'],
      "loginType": "RENAULT_IPN",
      "personRowId": personIdNew
    }

    await this.handleApiCall(firstValueFrom(this.contactsservice.createUsers(`${this.Config.ApinewContactsUrl}users`, newIpnCreate)))
    const data12 = await this.handleApiCall(firstValueFrom(this.contactsservice.createEmailAddress(`${this.Config.ApinewContactsUrl}emailAddresses`, createEmail)))
    const udpateEmail = {
      "personRowId": personIdNew,
      "addressType": "EMAIL",
      "addressIdentifier": data12['identifier'],
      "summary": data12['email'],
      "addressId": data12['rowId']
    }
    await this.handleApiCall(firstValueFrom(this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpateEmail)))


    if (ipnData['Phone']) {
      for (let i = 0; i < ipnData['Phone'].length; i++) {
        updates[i] = ipnData['Phone'][i];
      }
      const phoneUpdate1 =
      {
        phoneType: 'F',
        phoneNumber: updates[0].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim()
      }
      const data21 = await this.handleApiCall(firstValueFrom(this.contactsservice.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, phoneUpdate1)))
      const udpatePhone = {
        "personRowId": personIdNew,
        "addressType": "TELEPHONE",
        "addressId": data21['rowId']
      }
      await this.handleApiCall(firstValueFrom(this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpatePhone)))

    }
    if (ipnData['MobilePhoneNumber']) {
      for (let i = 0; i < ipnData['MobilePhoneNumber'].length; i++) {
        updatePhone[i] = ipnData['MobilePhoneNumber'][i]
      }
      const cellPhoneUpdate1 =
      {
        phoneType: 'P',
        phoneNumber: updatePhone[0].replaceAll(/\s/g, '').replaceAll(/-/g, '').replaceAll(/\+\+/g, '+').trim()
      }
      const data31 = await this.handleApiCall(firstValueFrom(this.contactsservice.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, cellPhoneUpdate1)))
      const udpatePhone = {
        "personRowId": personIdNew,
        "addressType": "TELEPHONE",
        "addressId": data31['rowId']
      }
      await this.handleApiCall(firstValueFrom(this.contactsservice.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, udpatePhone)))

    }
    await this.updateCheckIPNRolesSync(ipnData, personIdNew, ipnUpdateId, companyData, allRoles, 1, [], [], [], rolesExists);
  }

  async updateCheckIPNRolesSync(ipnData, personRowId, ipnUpdateId, companyData, allRoles = [], page = 1, multiRoleUpdate = [], archiveObj = [], subscribeData = [], rolesExists = []) {
    if (allRoles.length > 0) {
      if (this.personRoles == null) {
        const data = await this.handleApiCall(firstValueFrom(this.contactsservice.getPersonRoles(`${this.Config.ApinewContactsUrl}personRoles?personRowId=${personRowId}&_page=${page}`)))
        this.personRoles = data
      }
      if (this.personRoles['personRoles'].length > 0) {
        this.personRoles['personRoles'].forEach(e => {
          subscribeData.push(e);
        });
        if (this.personRoles['maxPage'] > 1 && this.personRoles['maxPage'] != page) {

          await this.updateCheckIPNRolesSync(ipnData, personRowId, ipnUpdateId, companyData, allRoles, page + 1, multiRoleUpdate, archiveObj, subscribeData, rolesExists);
        } else if (this.personRoles['maxPage'] == page) {
          let anotherRoleExist: any = false;
          subscribeData.forEach(roleObj => {
            const roleRCF = roleObj.roleTypeCode.toLowerCase();
            if (allRoles.indexOf(roleObj.roleTypeCode) == -1) {
              archiveObj.push(roleObj.rowId);
            }
            allRoles.forEach(e => {
              if (roleRCF == e.toLowerCase() && rolesExists.filter(x => x.roleTypeCode.toLowerCase() == roleRCF.toLowerCase()).length > 0) {
              } else {
                anotherRoleExist = true;
                if (multiRoleUpdate.findIndex(x => x == e) == -1) {
                  multiRoleUpdate.push(e);
                }
              }
            });
          });
          if (anotherRoleExist == true) {
            multiRoleUpdate.forEach(async e => {
              await this.createNewRoleContactSync(personRowId, e, companyData, ipnData['Uid'], rolesExists);
            });
          }
          const archiveDate = { endDate: this.commonService.getTodayDate() }
        } else {
        }
      } else {
        allRoles.forEach(async e => {
          await this.createNewRoleContactSync(personRowId, e, companyData, ipnData['Uid'], rolesExists);
        });
      }

    } else if (allRoles.length == 0) {
      allRoles.push('DCC');
      const data1 = await this.handleApiCall(firstValueFrom(this.contactsservice.getPersonRoles(`${this.Config.ApinewContactsUrl}personRoles?personRowId=${personRowId}&_page=${page}`)))
      if (data1['personRoles'].length > 0) {
        data1['personRoles'].forEach(e => {
          subscribeData.push(e);
        });
        if (data1['maxPage'] > 1 && data1['maxPage'] != page) {
          await this.updateCheckIPNRolesSync(ipnData, personRowId, ipnUpdateId, companyData, allRoles, page + 1, multiRoleUpdate, archiveObj, subscribeData, rolesExists);
        } else if (data1['maxPage'] == page) {
          let otherRolesExist = false;
          subscribeData.forEach(async roleObj => {
            if (roleObj.roleTypeCode.toLowerCase() == 'sal') {
              roleObj.roleTypeCode = 'sales contact';
            }
            if (this.allowedRoles.indexOf(roleObj.roleTypeCode.toLowerCase()) != -1) {
              await this.handleApiCall(firstValueFrom(this.contactsservice.deletePersonRoles(`${this.Config.ApinewContactsUrl}personRoles/${roleObj.rowId}`)))
                ;
            } else if (this.allowedRoles.indexOf(roleObj.roleTypeCode.toLowerCase()) == -1) {
              if (rolesExists.filter(x => x.roleTypeCode.toLowerCase() == roleObj.roleTypeCode.toLowerCase()).length > 0) {
                otherRolesExist = true;
              }
            } else {
            }
          });
          if (otherRolesExist == false) {
            await this.createNewRoleContactSync(personRowId, 'DCC', companyData, ipnData['Uid'], rolesExists);
          }
        } else {
        }
      } else {
        await this.createNewRoleContactSync(personRowId, 'DCC', companyData, ipnData['Uid'], rolesExists);
      }

    } else {
    }
  }
  async createNewRoleContactSync(personRowId, role, companyData, _ipn, rolesExists = []) {
    try {
      if (role.toLowerCase() == 'sales contact') {
        role = 'SAL';
      }
      const rolealreadyexists = rolesExists.filter(x => x.roleTypeCode == role)

      if (rolealreadyexists.length == 0) {
        const newCompanyLink =
        {
          personRowId: personRowId,
          startDate: this.commonService.getTodayDate(),
          personSupplierCompany: `CtcSupplierCompanyService:${companyData['rowId']}`,
          personRoleStatus: 'VALIDATED',
          roleTypeCode: role,
          roleTypeId: this.roleTypeDesc[role].rowId
        }

        await this.handleApiCall(firstValueFrom(this.contactsservice.createSupplierCompanyRoles(`${this.Config.ApinewContactsUrl}supplierCompanyRoles`, newCompanyLink)))
      }
    } catch (e) {
    }
  }
  async handleApiCall(apiCall: Promise<any>, _errorMessage = 'error') {
    try {
      return await apiCall;
    } catch (error) {
      if (error.includes(this.HTTP_NOT_FOUND_CODE)) {
        return null;
      }
    }
  }

}


